<template>
  <div>
    <section class="page-title contrato pf-title">
      <div class="center">
        <router-link to="/pessoafisica" class="back-button fas fa-angle-left"></router-link>
        <p class="label-planos">Pessoa Física</p>
        <h1 class="the-title">Contrato</h1>
      </div>
    </section>

    <section class="page-content center planos-form">
      <div v-if="e1 == 6">
        <div class="plano-selecionado" style="background: #f1f1f1; margin-bottom: 10px" v-for="titulo in tituloContratacao" :key="titulo"><span>{{titulo}}</span></div>
      </div>
      <div v-else>
        <div class="plano-selecionado" style="background: #f1f1f1;" v-if="this.planoSelecionado.qualificacao == 'Individual'"><span>{{this.planoSelecionado.name}} - {{this.planoSelecionado.registro}} - R$ {{this.planoSelecionado.value}} (Por pessoa) - {{this.planoSelecionado.cobertura}}</span></div>
        <div class="plano-selecionado" style="background: #f1f1f1;" v-else><span>{{this.planoSelecionado.name}} - {{this.planoSelecionado.registro}} - R$ {{this.planoSelecionado.value}} (Até 4 pessoas) - {{this.planoSelecionado.cobertura}}</span></div>
      </div>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Primeiro Acesso</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos" >Dados Pessoais</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4" :editable="editPassos">Endereço</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 5" step="5" :editable="editPassos">Beneficiários</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="6" :editable="editPassos">Contratar o Plano</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- PASSO 1 -->
          <v-stepper-content step="1">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg3>
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF*"
                      v-validate="'required|cpf'"
                      :error-messages="errors.collect('cpf')"
                      return-masked-value mask="###.###.###-##"
                      data-vv-name="cpf"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg5>
                    <v-text-field
                      v-model="financialManagers.email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      label="E-mail*"
                      data-vv-name="email"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>
                    <v-text-field
                      v-model="financialManagers.password"
                      label="Senha*"
                      v-validate="'required'"
                      :error-messages="errors.collect('senha')"
                      type="password"
                      ref="password"
                      data-vv-name="senha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>
                    <v-text-field
                      v-model="financialManagers.confirmPassword"
                      label="Repetir Senha*"
                      type="password"
                      :error-messages="errors.collect('password')"
                      v-validate="'required|confirmed:password'"
                      data-vv-name="password"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>
                    <v-text-field
                      v-model="financialManagers.firstName"
                      label="Nome Completo*"
                      box
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('firstName')"
                      data-vv-name="firstName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="Celular*"
                      return-masked-value mask="(##)#####-####"
                      v-validate="'required'"
                      :error-messages="errors.collect('Celular')"
                      data-vv-name="Celular"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <v-select
                      box
                      v-model="financialManagers.state"
                      :items="estados"
                      item-text="prefix"
                      item-value="codeS4"
                      label="UF*"
                      v-validate="'required'"
                      :error-messages="errors.collect('uf')"
                      data-vv-name="uf"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-if="linkParceriaAvanti">
                    <v-text-field
                      v-model="financialManagers.matricula"
                      label="Nº da Carteirinha Avanti"
                      type="number"
                      disabled
                      v-validate="'required'"
                      :error-messages="errors.collect('carteirinha')"
                      data-vv-name="carteirinha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-if="linkParceriaIgrejas">
                    <v-text-field
                      v-model="financialManagers.matricula"
                      label="Nº da Carteirinha de Membro"
                      type="number"
                      disabled
                      v-validate="'required'"
                      :error-messages="errors.collect('carteirinha')"
                      data-vv-name="carteirinha"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#00b21e" @click="consultaCpfInadimplente()">Continuar</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 1 -->

          <!-- PASSO 2 -->
          <v-stepper-content step="2">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg8>
                    <v-text-field
                      disabled
                      v-model="financialManagers.firstName"
                      label="Nome Completo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-select
                      v-model="financialManagers.gender"
                      label="Sexo*"
                      v-validate="'required'"
                      :error-messages="errors.collect('gender')"
                      data-vv-name="gender"
                      :items="generos"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="dataNasc"
                      label="Data de Nascimento*"
                      v-validate="'required|date_format:dd/MM/yyyy'"
                      :error-messages="errors.collect('dateOfBirth')"
                      return-masked-value mask="##/##/####"
                      data-vv-name="dateOfBirth"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-select
                      v-model="financialManagers.maritalStatus"
                      label="Estado Civil*"
                      v-validate="'required'"
                      :error-messages="errors.collect('maritalStatus')"
                      data-vv-name="maritalStatus"
                      :items="estadoscivil"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.susNumber"
                      label="CNS (Cartão do SUS)"
                      v-validate="'cns'"
                      :error-messages="errors.collect('cns')"
                      data-vv-name="cns"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.rg"
                      label="RG*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rg')"
                      data-vv-name="rg"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.rgEmitter"
                      label="Órgão Expedidor*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rgEmissor')"
                      data-vv-name="rgEmissor"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>
                    <v-text-field
                      v-model="financialManagers.motherName"
                      label="Nome da Mãe*"
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('motherName')"
                      data-vv-name="motherName"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>
                    <v-text-field
                      v-model="financialManagers.email"
                      label="E-mail"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.homePhone"
                      return-masked-value mask="(##)####-####"
                      label="Telefone Fixo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="Celular*"
                      return-masked-value mask="(##)#####-####"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cellPhone2"
                      label="Whatsapp"
                      return-masked-value mask="(##)#####-####"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-radio-group v-model="financialManagers.contratanteTitular" row :disabled="!radioBTtitular">
                      <strong style="font-weight: bold;">O contratante será o beneficiário titular do plano? &nbsp;&nbsp;</strong>
                      <v-radio color="#00b21e" label="Sim" :value="true"></v-radio>
                      <v-radio color="#00b21e" label="Não" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#00b21e" @click="avancaPasso3()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark @click="salvarContinuar()" color="blue-grey darken-1">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 2 -->

          <!-- PASSO 3 --> 
          <v-stepper-content step="3">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <!-- RG1 -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file1"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesRg1"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg1"
                      ref="upload1"
                    >
                      <p class="form-titulo" style="font-size: 20px">RG (FRENTE)*</p>
                      <v-btn style="border-radius: 8px;" large dark color="#00b21e">Selecionar arquivo</v-btn>
                      <p id="rg1" value="" hidden></p>
                      <p v-if="filesRg1 == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesRg1" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>
                  </v-flex>

                  <!-- RG2 -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file2"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesRg2"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg2"
                      ref="upload2"
                    >
                      <p class="form-titulo" style="font-size: 20px">RG (VERSO)*</p>
                      <v-btn style="border-radius: 8px;" large dark color="#00b21e">Selecionar arquivo</v-btn>
                      <p id="rg2" value="" hidden></p>
                      <p v-if="filesRg2 == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesRg2" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>
                  </v-flex>

                  <!-- CPF -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file3"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesCPF"
                      @input-filter="inputFilter"
                      @input-file="inputFileCPF"
                      ref="upload3"
                    >
                      <p class="form-titulo" style="font-size: 20px">CPF*</p>
                      <v-btn style="border-radius: 8px;" large dark color="#00b21e">Selecionar arquivo</v-btn>
                      <p id="cpf" value="" hidden></p>
                      <p v-if="filesCPF == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesCPF" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>
                  </v-flex>

                  <!-- ENDEREÇO -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file4"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesAddress"
                      @input-filter="inputFilter"
                      @input-file="inputFileAddress"
                      ref="upload4"
                    >
                      <p class="form-titulo" style="font-size: 20px">Comp. de Endereço*</p>
                      <v-btn style="border-radius: 8px;" large dark color="#00b21e">Selecionar arquivo</v-btn>
                      <p id="address" value="" hidden></p>
                      <p v-if="filesAddress == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesAddress" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>                        
                  </v-flex>

                  <!-- OUTROS -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file5"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesOutros"
                      @input-filter="inputFilter"
                      @input-file="inputFileOutros"
                      ref="upload5"
                    >
                      <p class="form-titulo" style="font-size: 20px">Outros*</p>
                      <v-btn style="border-radius: 8px;" large dark color="#00b21e">Selecionar arquivo</v-btn>
                      <p id="outros" value="" hidden></p>
                      <p v-if="filesOutros == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesOutros" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#00b21e" @click="avancaPasso4()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1" @click="salvarContinuar()">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 3 -->

          <!-- PASSO 4 -->
          <v-stepper-content step="4">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cep"
                      label="CEP*"
                      return-masked-value mask="#####-###"
                      v-validate="'required'"
                      :error-messages="errors.collect('cep')"
                      data-vv-name="cep"
                      @blur="retornoCEP()"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg9>
                    <v-text-field
                      v-model="financialManagers.address"
                      label="Rua"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <v-text-field
                      v-model="financialManagers.addressNumber"
                      label="Número*"
                      type="number"
                      v-validate="'required'"
                      :error-messages="errors.collect('numero')"
                      data-vv-name="numero"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="bairro"
                      label="Bairro"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="cidade"
                      label="Cidade"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="estado"
                      label="Estado"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-text-field
                      v-model="financialManagers.addressComplement"
                      label="Complemento"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#00b21e" @click="avancaPasso5()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1" @click="salvarContinuar()">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 4 -->

          <!-- PASSO 5 -->
          <v-stepper-content step="5">  
            <v-alert :value="alertTitular" type="info" color="primary">Informe um Titular para o plano!</v-alert>
            <v-container fluid grid-list-md>
              <v-data-iterator
                v-if="!alertTitular"
                :items="dependentes"
                :rows-per-page-items="rowsPerPageItems"
                rows-per-page-text="Linhas por página" 
                :pagination.sync="pagination"
                content-tag="v-layout"
                row
                wrap
                hide-actions
              >
                <template v-slot:header>
                  <v-toolbar style="border-radius: 10px;" class="mb-2" color="#00b21e" dark flat>
                    <v-toolbar-title>Titular/Dependentes</v-toolbar-title>
                  </v-toolbar>
                </template>
                <template v-slot:item="props">
                  <v-flex xs12 sm6 md4 lg4>
                    <v-card style="border-radius: 10px;">
                      <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>
                      <v-divider></v-divider>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >R$ {{ props.item.valuePlan }}</v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                          <v-btn style="border-radius: 8px;" dark color="blue-grey darken-1" @click="editItem(props.item)">Editar</v-btn>
                          <v-btn v-if="!props.item.isHolder" style="border-radius: 8px;" dark color="error" @click="openDialogDelete(props.item)">Excluir</v-btn>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </template>      
              </v-data-iterator>
            </v-container>
            <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-flex xs12 sm12 lg12>
              <v-container grid-list-md v-if="!alertTitular">
                <v-layout row wrap justify-center>
                  <v-btn @click="openDialogDependete()" dark style="border-radius: 8px;" large color="#cc9966" :disabled="inserirDepBloq">Incluir Dependente</v-btn>
                </v-layout>
              </v-container>         
            </v-flex>
            <v-dialog v-model="dialog" max-width="850px" persistent>
              <v-card>
                <v-card-title v-if="!dependents.isHolder">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-title v-else>
                  <span class="headline">{{ formTitleTitular }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 lg12 v-if="dependents.isHolder">
                        <v-select
                          disabled
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 v-else>
                        <v-select
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg4 v-if="!dependents.isHolder">
                        <v-select
                          v-model="dependents.parentage"
                          label="Parentesco*"
                          v-validate="'required'"
                          :error-messages="errors.collect('parentage')"
                          data-vv-name="parentage"
                          :items="parentesco"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg8 v-if="!dependents.isHolder">
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome Completo*"
                          box
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 v-else>
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome Completo*"
                          box
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-text-field
                          v-model="dependents.cpf"
                          label="CPF*"
                          v-validate="'required|cpf'"
                          :error-messages="errors.collect('cpfDep')"
                          return-masked-value mask="###.###.###-##"
                          data-vv-name="cpfDep"
                          box
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-text-field
                          v-model="dataNascDependent"
                          label="Data de Nascimento*"
                          v-validate="'required|date_format:dd/MM/yyyy'"
                          :error-messages="errors.collect('dateOfBirthDep')"
                          return-masked-value mask="##/##/####"
                          data-vv-name="dateOfBirthDep"
                          box
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-text-field
                          v-model="dependents.susNumber"
                          label="CNS (Cartão do SUS)"
                          v-validate="'cns'"
                          :error-messages="errors.collect('cns')"
                          data-vv-name="cns"
                          box
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-select
                          v-model="dependents.maritalStatus"
                          label="Estado Civil*"
                          v-validate="'required'"
                          :error-messages="errors.collect('maritalStatusDep')"
                          data-vv-name="maritalStatusDep"
                          :items="estadoscivil"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-select
                          v-model="dependents.gender"
                          label="Sexo*"
                          v-validate="'required'"
                          :error-messages="errors.collect('genderDep')"
                          data-vv-name="genderDep"
                          :items="generos"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg6>
                        <v-text-field
                          v-model="dependents.motherName"
                          label="Nome da Mãe*"
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('motherNameDep')"
                          data-vv-name="motherNameDep"
                          box
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                  <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DEPENDENTES --> 

            <!-- DIALOG DELETA DEPENDENTE -->
            <v-dialog v-model="dialogDelete" max-width="600px" persistent> 
              <v-card>
                <v-card-title>
                  <span class="headline">Confirmação de Exclusão</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-card-text>Dependente: {{dependents.firstName}}</v-card-text>
                    <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="deleteDependente()">Excluir</v-btn>
                  <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DELETA DEPENDENTE -->

            <!-- DIALOG CARTÃO DE CRÉDITO -->
            <v-dialog v-model="dialogCartao" max-width="900px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Pagamento com Cartão de Crédito</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-flex xs12 sm12 lg12>            
                    <p style="color:#F57C00" class="subtotal">O cartão deve pertencer ao responsável financeiro*</p>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 >
                    <p class="form-titulo">Dados do Cartão de Crédito</p>
                  </v-flex>             
                  <v-layout row wrap>
                    <v-flex d-flex xs12 sm6 md6>
                      <vue-card :number='modelCartao.cartao.numero' :cvv='modelCartao.cartao.codigoSeguranca' :mes='modelCartao.cartao.expiracaoMes' :nome='modelCartao.cartao.nome' :ano='validadeCartaoAno' animate :side='side'/>
                    </v-flex>
                    <v-flex d-flex xs12 sm6 md6>
                      <v-layout row wrap>
                        <v-flex d-flex xs12 sm6 md12>
                          <v-text-field              
                            v-model="modelCartao.cartao.nome"
                            label="Nome (Como está impresso no Cartão)"
                            v-validate="'required'"
                            :error-messages="errors.collect('nomeCartao')"
                            data-vv-name="nomeCartao"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="modelCartao.cartao.numero"
                            label="Número do Cartão"
                            v-validate="'required'"
                            :error-messages="errors.collect('numCartao')"
                            data-vv-name="numCartao"
                            mask="#### #### #### ####"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-select
                            v-model="modelCartao.cartao.bandeira"
                            label="Bandeira"
                            v-validate="'required'"
                            :error-messages="errors.collect('bandeiraCartao')"
                            data-vv-name="bandeiraCartao"
                            :items="bandeiras"
                            item-text="text"
                            item-value="value"
                            box
                            @keydown="side=1"
                          ></v-select>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4>          
                          <v-text-field
                            v-model="modelCartao.cartao.expiracaoMes"
                            label="Validade Mês"
                            v-validate="`required`"
                            :error-messages="errors.collect('expiraCartaoMes')"
                            data-vv-name="expiraCartaoMes"
                            return-masked-value mask="##"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4> 
                          <v-select
                            v-model="validadeCartaoAno"
                            label="Validade Ano*"
                            v-validate="'required'"
                            :error-messages="errors.collect('expiraCartaoAno')"
                            data-vv-name="expiraCartaoAno"
                            :items="anoValidade"
                            @keydown="side=1"
                            box
                          ></v-select>
                        </v-flex>                    
                        <v-flex d-flex xs12 sm6 md4> 
                          <v-text-field
                            v-model="modelCartao.cartao.codigoSeguranca"
                            label="CVV"
                            v-validate="`required`"
                            :error-messages="errors.collect('codCartao')"
                            data-vv-name="codCartao"
                            mask="####"
                            box
                            @keydown="side=2"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <v-text-field
                        v-model="modelCartao.cartao.nome"
                        label="Nome (Como está impresso no Cartão)"
                        v-validate="'required'"
                        :error-messages="errors.collect('nomeCartao')"
                        data-vv-name="nomeCartao"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field
                        v-model="modelCartao.cartao.numero"
                        label="Número do Cartão"
                        v-validate="'required|credit_card'"
                        :error-messages="errors.collect('numCartao')"
                        data-vv-name="numCartao"
                        mask="#### #### #### ####"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        v-model="modelCartao.cartao.codigoSeguranca"
                        label="Código de Segurança"
                        v-validate="'required'"
                        :error-messages="errors.collect('codCartao')"
                        data-vv-name="codCartao"
                        box
                        type="number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        v-model="validadeCartao"
                        label="Validade Mês/Ano"
                        v-validate="`required|date_format:MM/yyyy|date_between:${this.formatDateCartao(new Date().toISOString().substr(0, 7))},12/2100`"
                        :error-messages="errors.collect('expiraCartao')"
                        data-vv-name="expiraCartao"
                        return-masked-value mask="##/####"
                        box
                      ></v-text-field>
                    </v-flex> -->
                  </v-layout>  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="(this.pagamentoTipoCartao != 'mensal' && this.financialManagers.reteveAdesao == false) || (this.pagamentoTipoCartao != 'mensal' && this.financialManagers.reteveAdesao == true)" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="pagamentoTipoCartao == 'mensal' ? pagarCartao() : gerarBoletoCartao('anual')">Confirmar</v-btn>
                    <v-btn v-if="this.pagamentoTipoCartao == 'mensal' && this.financialManagers.reteveAdesao == true" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="enviarProposta()">Confirmar</v-btn>
                    <v-btn v-if="this.pagamentoTipoCartao == 'mensal' && this.financialManagers.reteveAdesao == false" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="gerarPixCartao">Confirmar</v-btn>
                    <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close()">Cancelar</v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG CARTÃO DE CRÉDITO --> 
        
            <br>
            <v-flex xs12 sm12 lg12 v-if="alertTitular">
              <v-container grid-list-md>
                <v-layout row wrap justify-center>
                  <v-btn style="border-radius: 8px;" large dark color="#cc9966" @click="openDialog()">Incluir Titular</v-btn>
                </v-layout>
              </v-container>
              <br>
              <br>
            </v-flex>
            <div class="separator dark"></div>
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 lg12>
                  <div class="total-table">
                    <p class="form-titulo" >Valores</p>
                    <div class="row-table-wrapper">
                      <div class="col" style="width: 36%;">
                        <div class="row-table titular">
                          <p>Beneficiário Titular</p>
                          <span class="total">R$ {{valorTitular.replace('.',',')}}</span>
                        </div>
                        <div class="row-table dependentes-row">
                          <p>Dependente(s)</p>
                          <span class="total">R$ {{valorDependentes.replace('.',',')}}</span>
                        </div>
                      </div>
                      <div class="col" style="margin-right: 14%;"  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                        <div class="row-table total-row">
                          <p>Total a pagar + Taxa de Implantação</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>                        
                      </div>
                      <div class="col" style="margin-right: 14%;" v-else>
                        <div class="row-table total-row">
                          <p>Total a pagar</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>                        
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
                </v-flex>
              </v-layout>
            </v-container>    
            <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-card-actions>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn style="border-radius: 8px;" large dark color="#00b21e" @click="avancaPasso6()">Continuar</v-btn>
                  </v-flex>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn @click="salvarContinuar()" style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1">Salvar e continuar depois</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-stepper-content>
          <!-- FIM DO PASSO 5 -->

          <!-- PASSO 6 -->
          <v-stepper-content step="6">
            <v-card class="mb-5" min-height="200px" flat>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg12 v-if="exibeVendedor">
                    <p class="form-titulo" >Corretor</p>
                    <v-flex xs12 sm12 lg12>
                      <v-radio-group v-model="temVendedor" row :disabled="linkVendedor">
                        <strong style="font-weight: bold;">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                        <v-radio color="#446fb5" label="Sim" :value="true"></v-radio>
                        <v-radio color="#446fb5" label="Não" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="!linkVendedor">
                      <v-text-field
                        v-if="temVendedor ? true : cpfVendedor = ''"
                        v-model="cpfVendedor"
                        label="CPF"
                        box
                        return-masked-value mask="###.###.###-##"
                        @blur="consultaVendedor()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field
                        v-if="temVendedor ? temVendedor == true : nomeVendedor = ''"
                        v-model="nomeVendedor"
                        label="Corretor"
                        box
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <hr>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <p class="form-titulo">Contrato</p>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg8 v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined">
                    <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg4>
                    <div v-for="item in documentosPlano" :key="item.id">
                      <div class="hidden-md-and-down" v-if="item.urlContrato">
                        <v-list-tile @click="pdfSelecionado = item.urlContrato" avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Contrato {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>

                      <div class="hidden-md-and-down" v-if="item.urlCobertura">
                        <v-list-tile @click="pdfSelecionado = item.urlCobertura" avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Cobertura {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>

                      <div class="hidden-lg-and-up" v-if="item.urlContrato">
                        <v-list-tile @click="pdfSelecionado = item.urlContrato" :href="item.urlContrato" target='_blank' avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Contrato {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>

                      <div class="hidden-lg-and-up" v-if="item.urlCobertura">
                        <v-list-tile @click="pdfSelecionado = item.urlCobertura" :href="item.urlCobertura" target='_blank' avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Cobertura {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg && this.financialManagers.ativaTermoAditivo == true">
                      <v-list-tile v-if="planoSelecionado.urlMinutaAditivo" @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar>
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Aditivo de redução de carência</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-if="!this.$vuetify.breakpoint.lg && this.financialManagers.ativaTermoAditivo == true">
                      <v-list-tile v-if="planoSelecionado.urlMinutaAditivo" @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar>
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Aditivo de redução de carência</v-list-tile-title>
                      </v-list-tile>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-checkbox v-model="contrataccept" color="#00b21e">
                      <span slot="label">Li e concordo com os termos do contrato</span>
                    </v-checkbox>

                    <v-checkbox v-if="this.financialManagers.ativaTermoAditivo == true" v-model="financialManagers.aceiteAditivoCarencia" color="#00b21e">
                      <span slot="label">Li e concordo com os termos do aditivo de redução de carência</span>
                    </v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12 v-if="planoSelecionado.name && planoSelecionado.name.includes('HOME CARE')">
                    <v-card elevation="1">
                      <v-card-title>
                        <h3 class="headline mb-0">Observações do plano</h3>
                      </v-card-title>
                      <v-card-text>
                        <p>1. Esse contrato possui Formação de Preço Pré-estabelecido e Fator Moderador Franquia</p>
                        <p>2. O CONTRATANTE pagará um valor fixo mensal referente ao plano contrato e os pagamentos referentes aos serviços de FRANQUIA serão pagos em espécie ou cartão no ato do atendimento</p>
                        <p>3. O que significa Franquia: É o valor financeiro a ser pago pelo beneficiário diretamente ao prestador da rede credenciada (CENTRO ORTODÔNTICO ORTO VITTA) no ato da utilização do serviço, por não ser responsabilidade contratual da operadora</p>
                        <p>4. Declaro que recebi no ato da assinatura deste contrato a tabela para pagamento dos serviços com regime de Franquia cobertos por este contrato</p>
                        <p>5. O valor referente aos pagamentos dos tratamentos que possuem o regime de franquia deverão ser pagos diretamente ao Credenciado: CENTRO ORTODÔNTICO ORTO VITTA, CNPJ: 16.857.359/0001-10, Rua Campos, n° 130, Bairro São José, Aracaju/SE, Contato: (79) 3216-8950 no ato do atendimento HOME CARE</p>
                        <p style="margin: 0px">6. Para fins de declaração de IR – Imposto de Renda referente aos valores pagos dos serviços de Franquia será emitido por (CENTRO ORTODÔNTICO ORTO VITTA, CNPJ: 16.857.359/0001-10)</p>
                      </v-card-text>
                      <v-card-actions style="padding: 0 16px 0">
                        <v-checkbox v-model="obsHomeCare" color="#00b21e">
                          <span slot="label">Li e concordo com as observações acima</span>
                        </v-checkbox>
                      </v-card-actions>
                    </v-card>
                    <br>
                  </v-flex>
                  <hr>
                  <br>
                  <v-flex xs12 sm12 lg12>
                    <p class="form-titulo" >Resumo da proposta</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Beneficiário Titular</p>
                      <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Dependente(s)</p>
                      <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                      <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                  
                    </div>
                    <div class="resumo" v-else>
                      <p style="margin-bottom: 0px;">Total a pagar</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                    </div>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="planoSelecionado.taxaImplantacao != '0,00'">
                    <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p>
                  </v-flex>
                  <hr>
                  <br>
                  <v-flex xs12 sm12 lg12>
                    <p class="form-titulo" >Pagamento</p>              
                  </v-flex>

                  <!-- CUPOM DE DESCONTO -->
                  <v-flex xs12 sm12 lg3>
                    <v-text-field
                      v-model="financialManagers.cupomDesconto"
                      label="Cupom de desconto"
                      box
                      dense
                      :disabled="cupomAplicado"
                      color="#8395A7" 
                    ></v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 sm12 lg3>
                    <v-btn style="border-radius: 8px;" large dark :disabled="cupomAplicado" color="#00b21e" @click="aplicaCupom()">Aplicar</v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-chip close v-model="cupomAplicado" color="teal" text-color="white">
                      <v-avatar>
                        <v-icon>check_circle</v-icon>
                      </v-avatar>
                      <span v-if="dadosCupom.dados && dadosCupom.dados.tipoValor == 'REAL'">Cupom de R$ {{dadosCupom.dados.valor}},00 aplicado</span>
                      <span v-if="dadosCupom.dados && dadosCupom.dados.tipoValor == 'PORCENTAGEM'">Cupom de {{dadosCupom.dados.valor}}% aplicado</span>
                    </v-chip>
                  </v-flex>
                  <v-layout row wrap v-if="!financialManagers.reteveAdesao">
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'CARTAO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4>
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Anual à Vista</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat((valorTotalProposta*12) - ((valorTotalProposta*12)*(this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoCartao('anual')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Anual Parcelado</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat(valorTotalProposta*12).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Em 12x de {{valorTotalProposta.replace('.',',')}}</h6>
                                <a @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                        
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4>
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Recorrente</h6>
                                <a @click="dialogoTipoPagamento = true" class="button">Continuar</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Plano Anual</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat((valorTotalProposta*12) - ((valorTotalProposta*12)*(this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoBoleto('anual')" class="button" >Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- ELSE -->
                  <v-layout row wrap v-else>
                    <br>
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'CARTAO'">           
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4>
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Enviar dados</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>  
                        <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Anual à Vista</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat((valorTotalProposta*11) - ((valorTotalProposta*11)*(this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoCartao('anual')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Anual Parcelado</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat(valorTotalProposta*11).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Em 11x de {{valorTotalProposta.replace('.',',')}}</h6>
                                <a @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                        
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4>
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Recorrente</h6>
                                <a @click="enviarProposta()" class="button">Enviar Proposta</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 lg4 v-if="!cupomAdesao">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; ">Plano Anual</h6>
                                <br>
                                <p class="price"><span>R$</span> {{parseFloat((valorTotalProposta*11) - ((valorTotalProposta*11)*(this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoBoleto('anual')" class="button" >Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-stepper-content>      
        </v-stepper-items>
        <!-- FIM DO PASSO 6 -->
      </v-stepper>

      <v-dialog v-model="dialogStep1" max-width="550px" max-height="300px" persistent>
        <v-card style="border-radius: 10px;">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
                <span class="total">Atenção</span>              
              </v-card-title>
              <v-container fill-height fluid pa-1 justify-center class="resumo">
                <p style="font-weight: bold;">Já existe um cadastro para este email. Para visualizar acesse a Área do Cliente ou clique em "Continuar" para prosseguir.</p>
              </v-container>
            </v-layout>
            <v-card-actions style="margin: 25px auto auto auto;">
              <v-container fill-height fluid pa-1 justify-center>
                <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 200px; margin-right: 10px" dark @click="confirmaContrato()">Área do Cliente</v-btn>
                <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 200px;" dark @click="continueStep2()">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogLoading" max-width="450px" max-height="300px" persistent> 
        <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
                <span class="total">Parabéns</span>              
              </v-card-title>
              <v-container fill-height fluid pa-1 justify-center class="resumo">
                <p class="resumo" style="text-align: center;">Sua proposta nº <span style="font-weight: 700;">{{financialManagers.proposalNumber}}</span> foi encaminhada para a Oral Santa Helena. Você poderá acompanhar o andamento da sua Proposta na Área do Cliente.</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container fill-height fluid pa-1 justify-center>
                <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoTipoPagamento" max-width="450px" max-height="300px">
        <v-card>
          <v-card-title>
            <p class="headline">Confirmação</p>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogoTipoPagamento = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p>Escolha como deseja pagar sua adesão.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="planoSelecionado.typePayment == 'BOLETO'" flat color="primary" @click="pagamentoBoleto('mensal')">Boleto</v-btn>
            <v-btn v-if="planoSelecionado.typePayment == 'CARTAO'" flat color="primary" @click="gerarBoletoCartao">Boleto</v-btn>
            <v-btn flat color="primary" @click="pagarPix">Pix</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoPix" max-width="600px" width="400px" persistent scrollable>
        <v-card>
          <v-card-title class="headline">QR Code</v-card-title>
          <v-card-text>
            <v-layout row wrap style="text-align: center">
              <v-flex xs12 sm12 md12 lg12>
                <img :src="'data:image/jpeg;base64,' + respostaPix.base64" width="100%" style="max-width: 300px">
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <v-btn dark color="#00695C" @click="doCopy('chavePix')" style="margin-bottom: 20px">Copiar Chave</v-btn>
                <v-text-field id="chavePix" v-model="respostaPix.copiaCola" readonly style="padding: 1px; position: absolute; left: -99999px;"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <p class="texto">Faça a leitura do QR Code ou copie a chave e cole no aplicativo de seu banco na função "Pix Copia e Cola". Após realizar o pagamento, aguarde a confirmação que pode levar até 02 (dois) minutos.</p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dialogoPix = false">Fechar</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-dialog>
    </section>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00b21e" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    <v-snackbar v-model="snackbar.ativo" :color="snackbar.cor" :timeout="snackbar.tempo">
      {{ snackbar.texto }}
      <v-btn dark flat @click="snackbar.ativo = false">X</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl, modelBoleto } from '@/global'
import CpfValidate from '../components/validators/rules/cpf'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import vueCard from 'vue-card-express'
export default {

components: {Snackbar, FileUpload, Loading, vueCard},
    data(){
        return {
          dialogoTipoPagamento: false,
          dialogoPix: false,
          snackbar: {
            ativo: false,
            cor: '',
            tempo: 5000,
            texto: '',
          },
          verificaPagamento: 0,
            cupomAplicado: false,
            side: 1,
            token: '',
            pagamentoTipoCartao: "",
            pegaDadosCartao: false,
            fullPage: true,  
            isLoading: false,  
            cartaValidado: false,        
            filesRg1: [],
            filesRg2: [],
            filesCPF: [],
            filesAddress: [],
            filesOutros: [], 
            dadosCupom: {
              mensagem: "",
              dados: null,
            },
            anoValidade: ['2020','2021','2022','2023','2024','2025','2026','2027','2028','2029','2030','2031','2032','2033','2034','2035'],           
            Anexos:
              {
                id: "ID_RESPONSAVEL_FINANCEIRO",
                imagesDocs: {
                  cpf: "",
                  rg: "",
                  rg2: "",
                  address: "",
                  credtFrontal: "",
                  physicalContract: "",
                  adtive: "",
                  others: ""
                }
              },
            rowsPerPageItems: [12, 18],
            pagination: {
              rowsPerPage: 12
            },
            exibeVendedor: true,
            linkParceriaIgrejas: false,
            linkParceriaAvanti: false,
            qtdDependentesInseridos: 0,
            pdfSelecionado: '',
            verificaTitularS4e: '',
            msgLoading: '',
            loading: false,
            financialManagUF: '',
            salesOralsantahelena: '5cc0a27ee2cead066040bfc9',
            brokerOralsantahelena: '5cc0a118e2cead066040bfc6',
            contrataccept: false,
            temVendedor: false,
            nomeVendedor: '',
            vendedorLink: [],
            vendedor: [],
            salesman: [],
            linkVendedor: false,
            cpfVendedor: '',
            inserirDepBloq: false,
            usarDadosFM: true,
            existeTitular: false,
            tipoTitular: false,
            radioBTtitular: true,
            alertTitular: false,
            editPassos: false,
            editedIndex: '',
            editedIndexTitular: '',
            valorDependentes: '0,00',
            valorTotalProposta: '0,00',
            valorTitular: '0,00',
            search: '',
            dialog: false,
            dialogDelete: false,
            dialogStep1: false,
            dialogLoading: false,
            dialogCartao: false,
            dependentes: [], 
            dependentesCarregados: [],            
            AtualFinancialManagers: [],           
            e1: 0,
            bairro: '',
            cidade: '',
            estado: '',
            estados: [],
            parentesco: [  
            { value: 'CÔNJUGE', text: "CÔNJUGE" },
            { value: 'FILHO', text: "FILHO(A)" },
            { value: 'PAI/MÃE', text: "PAI/MÃE" },
            { value: 'ENTEADO', text: "ENTEADO" },
            { value: 'AGREGADO', text: "AGREGADO/OUTROS" }
            ],
            generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" } ],
            bandeiras: [
            { value: 'DINERS', text: "DINERS" },
            { value: 'ELO', text: "ELO" },
            { value: 'HIPERCARD', text: "HIPERCARD" },
            { value: 'MASTERCARD', text: "MASTERCARD" },
            { value: 'VISA', text: "VISA" } ],
            estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" } ],
            planoSelecionado: [],
            dataNasc: '',
            dataNascDependent: '',
            dependents: {
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            defaultDependents: {
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            financialManagers:{
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: '',
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: 15,
                dateSignatureContract: '',
                formOfPaymentId: '',
                formOfPayment: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                autorizacaoCodigo: '',
                paymentId: '',
                TypeFm: 'FISICA',
                protocoloCancelamento: '',
                vendedor: '',
                CPFVendedor: '',
                matricula: '',
                stageForm: 2,
                tempPassword: false,
                originRegister: 'EXTERNO',
                existSales: '',
                salesmanId: '5cc0a27ee2cead066040bfc9',
                brokerId: '5cc0a118e2cead066040bfc6',
                qtdDependentes: '',
                situacaoBoleto: '',
                modalidadePagamento: '', 
                cupomDesconto: '',
                reteveAdesao: false,
                aceiteAditivoCarencia: false,
            },
            defaultfinancialManagers:{
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: 0,
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: -1,
                dateSignatureContract: '',
                formOfPaymentId: '',
                formOfPayment: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                autorizacaoCodigo: '',
                paymentId: '',
                TypeFm: 'FISICA',
                protocoloCancelamento: '',
                vendedor: '',
                CPFVendedor: '',
                matricula: '',
                stageForm: 2,
                tempPassword: false,
                originRegister: 'EXTERNO',
                existSales: '',
                salesmanId: '5cc0a27ee2cead066040bfc9',
                brokerId: '5cc0a118e2cead066040bfc6',
                qtdDependentes: '',
                situacaoBoleto: '',
                modalidadePagamento: '',
                cupomDesconto: '',
                reteveAdesao: false,                                   
                aceiteAditivoCarencia: false,
            },
            validarEmail: true,
            validarDataNascTit: true,
            validarDataNascDep: true,
            idBoleto: '',
            Sales: {
              status: 'PAGAMENTO PENDENTE',
              fMIPConfirm: '',
              fMConfirm: '',
              salesmanIPConfirm: '',
              financialManagerId: '',
              salesmanId: '',
              brokerId: '',
              salesmanConfirm: '',
              paymentId: '',
              boletoId: ''
            },
            validadeCartaoAno: '',
            modelCartao: 
            {
                id: '',
                valor: '',
                tipoTransacao: 'A_VISTA',
                quantidadeParcelas: 1,
                comprador: {
                  id: '',
                  documentoNumero: '',
                  documentoTipo: '1',
                  email: '',
                  nomeCompleto: '',
                  primeiroNome: '',
                  ultimoNome: '',
                  enderecoLogradouro: '',
                  enderecoNumero: '',
                  enderecoComplemento: '',
                  enderecoCep: '',
                  enderecoBairro: '',
                  enderecoCidade: '',
                  enderecoEstado: '',
                  
                },
                cartao: {
                  numero: '',
                  codigoSeguranca: '',
                  nome: '',
                  expiracaoAno: '',
                  expiracaoMes: '',
                  bandeira: ''
                }
              },
              defaltModelCartao: 
              {
                id: '',
                valor: '',
                tipoTransacao: 'A_VISTA',
                quantidadeParcelas: 1,
                comprador: {
                  id: '',
                  documentoNumero: '',
                  documentoTipo: '1',
                  email: '',
                  nomeCompleto: '',
                  primeiroNome: '',
                  ultimoNome: '',
                  enderecoLogradouro: '',
                  enderecoNumero: '',
                  enderecoComplemento: '',
                  enderecoCep: '',
                  enderecoBairro: '',
                  enderecoCidade: '',
                  enderecoEstado: '',
                  
                },
                cartao: {
                  numero: '',
                  codigoSeguranca: '',
                  nome: '',
                  expiracaoAno: '',
                  expiracaoMes: '',
                  bandeira: ''
                }
              },
              modelPix: {
                pagadorDocumentoTipo: 1,
                pagadorDocumentoNumero: '',
                pagadorNome: '',
                pagadorEndereco: '',
                pagadorBairro: '',
                pagadorCidade: '',
                pagadorUf: '',
                pagadorCep: '',
                dataVencimento: '',
                valorNominal: 0,
                multaPercentual: 0,
                multaQuantidadeDias: 0,
                jurosPercentual: 0,
                tipoDesconto: 0,
                descontoValor: 0,
                descontoDataLimite: '',
                valorAbatimento: 0,
                tipoProtesto: 0,
                protestoQuantidadeDias: 0,
                baixaQuantidadeDias: 0,
                mensagem: '',
                tipoTitulo: 4,
                nsu: '',
                nossoNumero: 0,
                seuNumero: '',
                convenioId: '81ae5518-3c16-4b45-962d-0150f9893a79',
                incluirPix: true,
                financialManagerId: ""
              },
              respostaPix: {
                base64: '',
                copiaCola: '',
                id: '',
              },
            steppers: {
              default: 0,
              type: Number
            },
            formOfPayment: {
              costCenterId: '',
              dayInclusion: '',
              type: ''
            },
            idUf: '',
            idUser: '',
            obsHomeCare: false,
            planos: [],
            selecaoPlano: '',
            documentosPlano: [],
            tituloContratacao: [],
            cupomAdesao: false,
            dictionary: {          
                custom: {
                uf: {
                    required: () => 'Informe a UF',
                },
                firstName: {
                    required: () => 'Informe nome e sobrenome', 
                    regex: () => 'Informe nome e sobrenome'                    
                },
                firstNameDep: {
                    required: () => 'Informe nome e sobrenome', 
                    regex: () => 'Informe nome e sobrenome'                    
                },
                email: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                password: {
                    required: () => 'Informe a Senha',
                    confirmed: () => 'A senha não confere'
                },
                senha: {
                    required: () => 'Informe a Senha'
                },
                dateOfBirth: {
                   required: () => 'Informe a Data de Nascimento' ,
                   date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                dateOfBirthDep: {
                   required: () => 'Informe a Data de Nascimento',
                   date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                gender: {
                   required: () => 'Informe o Sexo' 
                },
                genderDep: {
                   required: () => 'Informe o Sexo' 
                },
                maritalStatus: {
                   required: () => 'Informe o Estado Civil' 
                },
                maritalStatusDep: {
                   required: () => 'Informe o Estado Civil' 
                },
                motherName:{
                   required: () => 'Informe o nome da Mãe',
                   regex: () => 'Informe nome e sobrenome'
                },
                motherNameDep:{
                   required: () => 'Informe o nome da Mãe',
                   regex: () => 'Informe nome e sobrenome'
                },
                cep:{
                   required: () => 'Informe o CEP'
                },
                numero: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                parentage: {
                  required: () => 'Informe o Parentesco'
                },
                cpfDep: {
                  required:() => 'Informe o CPF'
                },
                nomeCompCartao: {
                    required: () => 'Informe o Nome',                   
                },
                emailCartao: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                cpfCartao: {
                  required:() => 'Informe o CPF'
                },
                priNomeCartao: {
                  required:() => 'Informe o Primeiro Nome'
                },
                ultNomeCartao: {
                  required:() => 'Informe o Último Nome'
                },
                cepCartao: {
                  required: () => 'Informe o CEP'
                },
                ruaCartao: {
                  required: () => 'Informe a Rua'
                },
                bandeiraCartao: {
                  required:() => 'Informe a bandeira'
                },
                numeroCartao: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                bairroCartao: {
                  required: () => 'Informe o Bairro'
                },
                cidadeCartao: {
                  required: () => 'Informe a Cidade'
                },
                estadoCartao: {
                  required: () => 'Informe o Estado'
                },
                numCartao: {
                  required: () => 'Informe o número do cartão de crédito',
                  credit_card:() => 'Número de Cartão Inválido'
                },
                nomeCartao: {
                  required: () => 'Informe o nome'
                },
                codCartao: {
                  required: () => 'Informe o código de segurança'
                },
                expiraCartaoMes: {
                  required: () => 'Informe o mês de validade do cartão',
                  /* date_between: () => 'Data de validade inválida',
                  date_format: () => 'Formato de data inválido' */
                },
                expiraCartaoAno: {
                  required: () => 'Informe o ano de validade do cartão',
                  /* date_between: () => 'Data de validade inválida',
                  date_format: () => 'Formato de data inválido' */
                },
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                },
                rg: {
                  required: () => 'Informe o número do RG'
                },
                rgEmissor: {
                  required: () => 'Informe o Órgão Expedidor do RG'
                },
                Celular: {
                  required: () => 'Informe o número do Celular'
                }               
            }
            } 

        }
    },
     mounted : function(){
      this.pegaUFs()
       //sessionStorage.getItem('email').clear()
        this.pegaParametrosUrl()
        if(sessionStorage.getItem('FinancialManager') != null)
        this.continuaProposta()
        else
        {
        this.planoSelecionado = JSON.parse(localStorage.getItem('planoSelecionado'))
        this.pdfSelecionado = this.planoSelecionado.urlMinutaContrato
        }
        if(sessionStorage.getItem('Vendedor') != null){
            this.vendedorLink = JSON.parse(sessionStorage.getItem('Vendedor'))
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite
            this.financialManagers.vendedor = this.vendedorLink.linkSite
            this.financialManagers.CPFVendedor = this.vendedorLink.cpf.replace(/[^\d]+/g,'')
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId            
        }
        this.$validator.localize('pt', this.dictionary)
        this.$store.dispatch('Logar')
        //this.valorTotalProposta = parseFloat(this.planoSelecionado.value) /* + parseFloat(this.valorTaxaImplantacao) */ 
    },
    watch: {
    dialog(val) {
    val || this.close()
      },

      cupomAplicado(val){
        if (val == false)
          this.excluiCupom()
      },

      dialogoPix(val) {
        if (val == false) {
          clearInterval(this.verificaPagamento)
        }
      },

      e1() {
        if (this.e1 == 6) {
          this.criaTituloPagina()
          // obtendo os documentos dos planos
          this.dependentes.forEach(async dependente => {
            await this.pegaDocumentos(dependente.plansId)
          })
        }
      },
    },
    computed: {       
        formTitle() {
          return this.editedIndex === '' ? 'Incluir Dependente' : 'Editar Dependente'
        },
        formTitleTitular() {
          return this.editedIndexTitular === '' ? 'Incluir Titular' : 'Editar Titular'
        }
    },
    methods: {
        editItem(item) {
          this.selecaoPlano = item.plansId
          this.editedIndex = item.id
          this.editedIndexTitular = item.id
          this.dependents = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
          if(item.isHolder == true)
          this.tipoTitular = true
          else
          this.tipoTitular = false
          this.dialog = true

        },
        async continuaProposta(){ 
          this.isLoading = true         
          if(sessionStorage.getItem('FinancialManager') != null){
          this.financialManagers = JSON.parse(sessionStorage.getItem('FinancialManager') || '[]')
          //this.planoSelecionado = this.financialManagers.planoSelecionado
          this.idUser = this.financialManagers.id
          this.dataNasc = this.formatDateBrz(this.financialManagers.dateOfBirth)        
          if(!this.financialManagers.contratanteTitular && this.financialManagers.stageForm >= 6)            
          this.existeTitular = true
          else
          this.existeTitular = false

          //Carrega as informações do Plano
          try {
              let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManagers.plansId}`) 
              if(res.data != ''){
                this.planoSelecionado = res.data[0] 
                this.pdfSelecionado = this.planoSelecionado.urlContrato 
              }              
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar plano","ERRO");
            }

          //Carrega as informações do Vendedor
          if(this.financialManagers.vendedor != '')
          {
            try {
                let res = await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${this.financialManagers.vendedor}`) 
                if(res.data != ''){
                  this.vendedorLink = res.data[0] 
                  this.temVendedor = true
                  this.linkVendedor = true
                  this.nomeVendedor = this.vendedorLink.linkSite  
                  this.financialManagers.salesmanId = this.vendedorLink.id  
                  this.financialManagers.brokerId = this.vendedorLink.brokerId 
                }              
              } catch (error) {
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar dados do vendedor","ERRO");
              } 
            }   
          
          //carregar endereço
          //this.retornoCEP()

          //carrega planos disponíveis para o contratante baseado na localidade
          await this.carregaDados()
          
          //Carrega estagio do Cadastro
            switch (this.financialManagers.stageForm) {
              case 2: 
                this.e1 = 2
                break;
              case 3:
                this.e1 = 3
                break;
              case 4:
                await this.carregaDependentes()
                this.e1 = 4
                break;
             case 5:
                await this.carregaDependentes()
                this.e1 = 5
                //this.avancaPasso5()
                break;
              case 6:
                await this.carregaDependentes()
                await this.avancaPasso6()                
                break;
              default:
                break;
            }
            this.isLoading = false
        }
        },
         async deleteDependente() {        
            await axios.post(baseApiUrl + 'Dependents/excluir', {"id": this.editedIndex})
            .then(() => {    
                this.carregaDependentes()
                this.close()                
            })
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao excluir dependente","ERRO");              
              this.close()
              })
        },
        
        async pegaUFs() {
          await axios.get(`${baseApiUrl}UFs`).then(res => {
            if (res.data) {
              this.estados = res.data
            }
          })
        },

        async carregaDados() {
          this.planos = []
          await axios.get(baseApiUrl + 'Plans?filter={"where":{"and":[{"typePayment":"' + this.planoSelecionado.typePayment + '"},{"abrangenciaId":"' + this.planoSelecionado.abrangenciaId + '"}]}}')
          .then(response => {
            if (response.data) {
              for (var key in response.data) {
                if (response.data.hasOwnProperty(key)) {
                  if (response.data[key].abrangenciaId) {
                    this.planos.push({
                      'codeS4': response.data[key].codeS4,
                      'familyTable': response.data[key].familyTable,
                      'id': response.data[key].id,
                      'name': response.data[key].name,
                      'value': response.data[key].value,
                      'qualificacao': response.data[key].qualificacao,
                      'descricao': response.data[key].name + " - R$" + response.data[key].value,
                      'registro': response.data[key].registro,
                      'cobertura': response.data[key].cobertura,
                    });
                  }
                }
              }
            }
          })
          .catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar os planos","ERRO");
          })
        },

        async consultaCpfInadimplente() {
          this.isLoading = true
          let res = await axios.post(`${baseApiUrl}APIS4s/AssociadosV2`, {"cpfDependente" : this.financialManagers.cpf}) 
            if(res.data != ''){
              if (res.data.inadimplente) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825","CPF possui inadimplência. Por favor, contate a Oral Santa Helena!","ATENÇÃO")
              } else {
                this.salvarPrimeiroAcesso()
              }
            }
        },

        async salvarPrimeiroAcesso(){

          await this.$validator.validate('email').then(valid => {
              if (!valid)
                this.validarEmail = false
              else
                 this.validarEmail = true
            });

            if(this.financialManagers.email == '' || this.financialManagers.firstName == '' || this.financialManagers.password == '' || this.financialManagers.cpf == '' || this.financialManagers.state == '' || this.financialManagers.confirmPassword == '' || this.financialManagers.cellPhone == '' || this.financialManagers.password != this.financialManagers.confirmPassword || !this.validarEmail)
            this.$validator.validateAll()
            else{   
            this.isLoading = true 
            var verificaemail = ''
            var verificaCancelamento

            await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"email": this.financialManagers.email}).then(res => {         
            if(res.data != ''){      
            verificaemail = res.data[0].email
            verificaCancelamento = res.data[0].protocoloCancelamento  
                }              	
            })
            if(verificaemail == '' || verificaCancelamento != ''){
              //this.financialManagers.planoSelecionado = this.planoSelecionado 
              this.financialManagers.plansId = this.planoSelecionado.id 
              this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()
              this.financialManagers.email = this.financialManagers.email.toLowerCase()               
                await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers ).then(res => {         
                if(res.data != ''){      
                    this.financialManagers.id = res.data.id
                    this.idUser = res.data.id
                    this.$validator.reset()
                    this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                    this.financialManagers.stageForm = 2
                    this.e1 = 2   
                    this.isLoading = false                 
                    }              	
                })
            }else
            {
              this.isLoading = false
              this.dialogStep1 = true
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825","Já existe um cadastro para esse email, acesse a Área do Cliente!","ATENÇÃO")
            }
            } 

        },
        async continueStep2() {
              this.financialManagers.plansId = this.planoSelecionado.id 
              this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()
              this.financialManagers.email = this.financialManagers.email.toLowerCase()               
                await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers ).then(res => {         
                if(res.data != ''){      
                    this.idUser = res.data.id
                    this.$validator.reset()
                    this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 6)+Math.floor(1000 + Math.random() * 1000)
                    this.financialManagers.stageForm = 2
                    this.salvarFinancialManager()
                    this.dialogStep1 = false
                    this.e1 = 2   
                    this.isLoading = false                 
                    }              	
                })            
        },

        async avancaPasso3(){ 
          
          await this.$validator.validate('dateOfBirth').then(valid => {
              if (!valid)
                this.validarDataNascTit = false
              else
                 this.validarDataNascTit = true
            });

            if(this.dataNasc == '' || this.financialManagers.maritalStatus == null || this.financialManagers.gender == null || this.financialManagers.cpf == '' || this.financialManagers.motherName == '' || !CpfValidate(this.financialManagers.cpf) || this.financialManagers.rg == '' || this.financialManagers.rgEmitter == '' || !this.validarDataNascTit)
            this.$validator.validateAll()
            else{  
            this.isLoading = true
            await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if(res.data.Data.length > 0){
               res.data.Data.forEach( (titular) => {
                if(titular.Dependente[0].Situacao == "1")
                    {
                      this.verificaTitularS4e = true
                    }
                else{ 
                      this.verificaTitularS4e = false
                    }
                })
              }
              else{ 
                this.verificaTitularS4e = false
              }              
            })         
            this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
            await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers )
            .then(res => { 
              if(res.data != ''){
              if(this.financialManagers.contratanteTitular && !this.verificaTitularS4e){
              this.dependents.valuePlan = this.planoSelecionado.value
              this.dependents.rcaId = '8'
              this.dependents.dateFirstPayment = new Date().toISOString().substr(0, 7).replace('-','')
              this.dependents.isHolder = true
              this.dependents.financialManagerId = this.idUser
              this.dependents.firstName = this.financialManagers.firstName
              this.dependents.dateOfBirth = this.financialManagers.dateOfBirth
              this.dependents.gender = this.financialManagers.gender
              this.dependents.maritalStatus = this.financialManagers.maritalStatus
              this.dependents.cpf = this.financialManagers.cpf
              this.dependents.motherName = this.financialManagers.motherName
              this.dependents.susNumber = this.financialManagers.susNumber
              this.dependents.plansId = this.planoSelecionado.id
              this.salvarTitular()
              this.financialManagers.stageForm = 3
              this.e1 = 3
              this.isLoading = false
              this.alertTitular = false
              this.radioBTtitular = false
              this.$validator.reset()
              }
              else
              if(!this.financialManagers.contratanteTitular)
              {
                this.e1 = 3
                this.financialManagers.stageForm = 3
                this.isLoading = false
                this.alertTitular = !this.financialManagers.contratanteTitular
                this.radioBTtitular = false
                this.$validator.reset()
              }
              else{
              this.isLoading = false
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
              }
              }
            })
             await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.idUser})
            .then(res => {        
            if(res.data != ''){
              this.existeTitular = true
              this.alertTitular = false
            }
            })
            }
        },

        async salvarFinancialManager(){
          try {
              await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers )            
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
            }
            /* await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.idUser}`, this.financialManagers ) 
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");              
              }) */
        },

         async salvarFinancialManagerEFinalizar(){
           if(this.planoSelecionado.typePayment == 'BOLETO' || this.planoSelecionado.typePayment == 'CARTAO' && this.financialManagers.reteveAdesao == false)
           {
            //Pegar o formOfPayment e salvar o FinancialManager
            this.financialManagers.vendedor = this.nomeVendedor
            this.financialManagers.nsu = modelBoleto.nsu
            this.financialManagers.situacaoBoleto = 'GERADO'
            this.financialManagers.nossoNumero = modelBoleto.nossoNumero
            this.financialManagers.vencimentoBoleto = modelBoleto.dataVencimento
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            //this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
            this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
            this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
            if (this.planoSelecionado.typePayment == 'BOLETO') {
              this.formOfPayment.type = 'BOLETO'
              // this.financialManagers.formOfPayment = 'BOLETO'
            } else {
              this.formOfPayment.type = 'CARTAO'
              // this.financialManagers.formOfPayment = 'CARTAO'
            }
            /* this.financialManagers.existSales = true  */
            this.Sales.boletoId = this.idBoleto 
           }
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers ) 
              if(res.data != ''){
                this.finalizaCadastro()
              }  
              else
              {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")
              }            
              } catch (error) {
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")                
              }                       
        },

        async avancaPasso4(){
          this.isLoading = true
          this.Anexos.id = this.idUser
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.address = document.getElementById("address").value
          this.Anexos.imagesDocs.others = document.getElementById("outros").value
          
            if(this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.address == undefined || this.Anexos.imagesDocs.others == undefined){
              this.isLoading = false
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos","ATENÇÃO")
            }            
            else{
            await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`,this.Anexos )
            .then(res => {        
            if(res.data != ''){
                this.e1 = 4
                this.financialManagers.stageForm = 4  
                this.isLoading = false
            }
            })
            .catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar Anexos, verifique os arquivos!","ERRO"); 
              return;             
              })                    
                this.salvarFinancialManager()
            }
        },        

        async avancaPasso5(){
            if(this.financialManagers.cep == '' || this.financialManagers.addressNumber == null || this.financialManagers.address == '' || this.financialManagers.city == '' || this.financialManagers.state == '' || this.financialManagers.district == '')
            this.$validator.validateAll()
            else{            
            this.isLoading = true
            //SALVA OS DEPENDENTES QUE FORAM CARREGADOS
            if(this.qtdDependentesInseridos < this.financialManagers.qtdDependentes)
              this.salvarDependentesCarregados()
            
            this.financialManagers.stageForm = 5 
            this.salvarFinancialManager()
            this.carregaDependentes()
            this.carregaDados()
            setTimeout(() => {            
            this.e1 = 5
            this.isLoading = false
            }, 2000);
            
            this.$validator.reset()                
            if(this.financialManagers.contratanteTitular == false && this.existeTitular == false)
            {
            this.openDialog()
            }
            else
            {
              this.alertTitular = false
              if(this.planoSelecionado.taxaImplantacao != '0,00')
              {
                this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.') + parseFloat(this.planoSelecionado.taxaImplantacao).replace(',', '.')).toFixed(2)
                this.valorTotalProposta = this.valorTitular
                
              }
              else
              {
                this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
                this.valorTotalProposta = this.valorTitular                
              }            
            }            
            }
        },

        async avancaPasso6(){          
          if(this.alertTitular){
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário informar o Titular do Plano!","ATENÇÃO")
          }
/*           else
          if(this.planoSelecionado.qualificacao.toUpperCase().includes('FAMILIAR') && this.qtdDependentesInseridos < 2 && this.financialManagers.matricula == '' && this.planoSelecionado.area_atuacao != 'AVANTI/PALMEIRAS' && this.planoSelecionado.area_atuacao != 'IGREJAS SP') {
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Para planos do tipo 'FAMILIAR' é necessário incluir pelo menos um dependente","ATENÇÃO")
          }  */         
          else{  
            this.isLoading = true 
            if(this.financialManagers.originRegister == 'INTERNO')
            this.exibeVendedor = false          
            else
            {
            this.exibeVendedor = true              
            this.financialManagers.responsibility = this.valorTotalProposta
            }
            this.financialManagers.stageForm = 6
            this.salvarFinancialManager()
         
            this.e1 = 6
            this.isLoading = false            

          }

        //Pegando codeS4 para salvar no FinancialManager
        await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.financialManagers.state}}}`).then(res => {        
            if(res.data != null){      
                this.financialManagUF = res.data[0].prefix
                this.idUf = res.data[0].id
            }
        })          
        },

        async verificaTitular(){        
            await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if(res.data.Data.length > 0)     
            this.verificaTitularS4e = true 
            else
            this.verificaTitularS4e = false         	
            })
        },

        async salvarContinuar(){
            this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
            this.financialManagers.stageForm = this.e1
            await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers ).then(res => {         
                if(res.data != ''){      
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#0288D1","Informações salvas com sucesso, para continuar depois, acesse a Área do Cliente!","INFORMAÇÃO")
                    }              	
                })
        },
        formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateCartao (date) {
        if (!date) return null

        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      async retornoCEP(){
          if(/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
            try {
              let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}) 
              if(res.data != ''){
                  this.financialManagers.address = res.data.Logradouro
                  this.cidade = res.data.Municipio
                  this.financialManagers.city = res.data.IdMunicipio
                  this.estado = res.data.Uf
                  this.financialManagers.state = res.data.IdUf
                  this.bairro = res.data.Bairro
                  this.financialManagers.district = res.data.IdBairro
                  this.financialManagers.addressType = res.data.IdTipoLogradouro
                  this.financialManagers.addressTypeName = res.data.TipoLogradouro

              } 
              else
              {
                var vmcep = this;
                vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.financialManagers.address = ''
                this.cidade = ''
                this.financialManagers.city = ''
                this.estado = ''
                this.financialManagers.state = ''
                this.bairro = ''
                this.financialManagers.district = ''
                this.financialManagers.addressType = '' 
              }             
              } catch (error) {
                  vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                  this.financialManagers.address = ''
                  this.cidade = ''
                  this.financialManagers.city = ''
                  this.estado = ''
                  this.financialManagers.state = ''
                  this.bairro = ''
                  this.financialManagers.district = ''
                  this.financialManagers.addressType = '' 
              }
          }           
      },

      async retornoViaCEP(){
        if(/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
            try {
              let res = await axios.get(`https://viacep.com.br/ws/${this.financialManagers.cep.replace(/[^\d]+/g,'')}/json/`) 
              if(res.data.erro == "true" || !res.data.bairro || !res.data.localidade || !res.data.uf){

                await this.retornoCEP()
   
              } 
              else
              {
                  this.cidade = res.data.localidade
                  this.estado = res.data.uf
                  this.bairro = res.data.bairro
              }             
              } catch (error) {
                  // var vmcep = this;
                  // vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                  this.cidade = ''
                  this.estado = ''
                  this.bairro = ''
                  await this.retornoCEP()
              }
          }         
      },

      async retornoCEPcartao(){
          if(/^[0-9]{5}-[0-9]{3}$/.test(this.modelCartao.comprador.enderecoCep)) {
          axios
          .post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.modelCartao.comprador.enderecoCep})
          .then(res => {        
            if(res.data != null){      
            this.modelCartao.comprador.enderecoLogradouro = res.data.Logradouro
            this.modelCartao.comprador.enderecoCidade = res.data.Municipio
            this.modelCartao.comprador.enderecoEstado = res.data.Uf
            this.modelCartao.comprador.enderecoBairro = res.data.Bairro
            } 
            else{
              var vmcepcart = this;
              vmcepcart.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.modelCartao.comprador.enderecoLogradouro = ''
                this.modelCartao.comprador.enderecoCidade = ''
                this.modelCartao.comprador.enderecoEstado = ''
                this.modelCartao.comprador.enderecoBairro = ''
            }             	
            })
          }           
      },
      async consultaVendedor(){
        if(CpfValidate(this.cpfVendedor)){
         await axios.get(`${baseApiUrl}Salesmans?filter[where][cpf]=${this.cpfVendedor}`).then(res => {        
            if(res.data != ''){
            this.vendedorLink = res.data[0] 
            this.temVendedor = true
            //this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite 
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId             
            }
            else{
              var vmcpfvend = this;
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
              this.nomeVendedor = '' 
           }         
          }) 
        }

      },
     /*  async carregaDependentes(){
        var count = 0
        var taxa = 0
        try {
              let res = await axios.get(`${baseApiUrl}Dependents?filter[where][financialManagerId]=${this.idUser}`)
              if(res.data != null){      
                this.dependentes = res.data            
                this.qtdDependentesInseridos = this.dependentes.length
                if(this.dependentes.length == 1)
                this.valorDependentes = '0,00'
                for (let index = 0; index < this.dependentes.length; index++) {
                  if(this.dependentes[index].isHolder) {
                  this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)              
                  }else
                  {
                  count++
                  this.valorDependentes = (parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2) * count).toFixed(2) 
                  }
                }  
                  taxa = count * parseFloat(this.planoSelecionado.taxaImplantacao) + parseFloat(this.planoSelecionado.taxaImplantacao) 
                  if(this.planoSelecionado.taxaImplantacao != '0,00')         
                  this.valorTotalProposta = (parseFloat(this.valorDependentes) + parseFloat(this.valorTitular) + parseFloat(taxa)).toFixed(2) 
                  else
                  this.valorTotalProposta = (parseFloat(this.valorDependentes) + parseFloat(this.valorTitular)).toFixed(2) 

                }             
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar os dependentes","ERRO") 
            }
            if(this.dependentes.length > 0){
                  this.alertTitular = false
                  this.existeTitular = true 
                  }
              else
              {
                  this.alertTitular = true
                  this.existeTitular = false 
            }
        
      }, */

      async carregaDependentes() {
        this.valorFaixa = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
        this.valorPlano = this.planoSelecionado.value
        this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
        this.valorDependentes = '0,00'
        var count = 0
        var taxa = 0
        let qtdDependentesFamilia = 0
        try {
          let res = await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.idUser})
          if (res.data != null) {
            this.dependentes = res.data.dependentes
            this.qtdDependentesInseridos = this.dependentes.length
            if (this.dependentes.length == 1)
              this.valorDependentes = '0,00'
            for (let index = 0; index < this.dependentes.length; index++) {
              if (!this.dependentes[index].isHolder) {
                count++
              }
            }
            taxa = count * parseFloat(this.planoSelecionado.taxaImplantacao) + parseFloat(this.planoSelecionado.taxaImplantacao)

            for (let i = 0; i < this.dependentes.length; i++) {
              if (this.financialManagers.plansId !== this.dependentes[i].plansId) {
                this.planosDiferentes = true
                break;
              } else {
                this.planosDiferentes = false
              }
            }            
            
            if (this.planosDiferentes == false) {
              //Trata faixa de usuários
              if (count + 1 == 2 && this.planoSelecionado.familyTable.value2 != '') {
                this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                this.valorTitular = this.planoSelecionado.familyTable.value2
                this.valorPlano = this.planoSelecionado.familyTable.value2
                this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count)).toFixed(2)
              } else if (count + 1 == 3 && this.planoSelecionado.familyTable.value3 != '') {
                this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                this.valorTitular = this.planoSelecionado.familyTable.value3
                this.valorPlano = this.planoSelecionado.familyTable.value3
                this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count)).toFixed(2)
              } else if (count + 1 >= 4 && this.planoSelecionado.familyTable.value4 != '') {
                this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value4.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                this.valorTitular = this.planoSelecionado.familyTable.value4
                this.valorPlano = this.planoSelecionado.familyTable.value4
                this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value4.replace(',','.')).toFixed(2) * (count)).toFixed(2)
              } else if (count + 1 >= 5 && this.planoSelecionado.familyTable.value5 != '') {
                this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value5.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                this.valorTitular = this.planoSelecionado.familyTable.value5
                this.valorPlano = this.planoSelecionado.familyTable.value5
                this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value5.replace(',','.')).toFixed(2) * (count)).toFixed(2)
              } else if (count + 1 >= 6 && this.planoSelecionado.familyTable.value6 != '') {
                this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value6.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                this.valorTitular = this.planoSelecionado.familyTable.value6
                this.valorPlano = this.planoSelecionado.familyTable.value6
                this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value6.replace(',','.')).toFixed(2) * (count)).toFixed(2)
              }

              if (this.planoSelecionado.taxaImplantacao != '0,00') {
                this.valorTotalProposta = (parseFloat(this.valorFaixa) + parseFloat(taxa)).toFixed(2) /* + parseFloat(this.valorTaxaImplantacao) */ 
                this.valorAnualProposta = this.valorTotalProposta.replace(',','.') * 12
              } else {
                this.valorTotalProposta = (parseFloat(this.valorFaixa)).toFixed(2) /* + parseFloat(this.valorTaxaImplantacao) */ 
                this.valorAnualProposta = this.valorTotalProposta.replace(',','.') * 12
              }
            }
            else {
              for (let i = 0; i < this.dependentes.length; i++) {
                if (this.retornaPlano(this.dependentes[i].plansId) == 'Familiar') {
                  qtdDependentesFamilia += 1;
                }
              }

              for (let i = 0; i < this.dependentes.length; i++) {
                for (let j = 0; j < this.planos.length; j++) {
                  if (this.dependentes[i].plansId == this.planos[j].id) {
                    if (qtdDependentesFamilia < 2) {
                      this.dependentes[i].valuePlan = this.planos[j].value
                    }
                    else {
                      if (this.planos[j].familyTable['value' + [qtdDependentesFamilia]]) {
                        if (this.planos[j].qualificacao === 'Familiar') {
                          this.dependentes[i].valuePlan = this.planos[j].familyTable['value' + qtdDependentesFamilia];
                        } else {
                          this.dependentes[i].valuePlan = this.planos[j].value;
                        }
                      }

                      else {
                        this.dependentes[i].valuePlan = null
                        
                        // eslint-disable-next-line
                        for (let g = qtdDependentesFamilia; g < 2; g--) {
                          if (this.planos[j].familyTable['value' + g] && this.planos[j].qualificacao == 'Familiar') {
                            this.dependentes[i].valuePlan = this.planos[j].familyTable['value' + g]
                            break
                          }
                        }

                        if (this.dependentes[i].valuePlan == null)
                          this.dependentes[i].valuePlan = this.planos[j].value;
                      }
                    }

                    if (this.dependentes[i].isHolder) {
                      this.valorTitular = this.dependentes[i].valuePlan
                    } else {
                      this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.dependentes[i].valuePlan.replace(',','.'))).toFixed(2)
                    }
                    /* if (count + 1 == 2 && this.planos[j].familyTable.value2 != '') {
                      this.dependentes[i].valuePlan = this.planos[j].familyTable.value2
                      this.valorFaixa = (parseFloat(this.planos[j].familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                      if (this.dependentes[i].isHolder) {
                        this.valorTitular = this.planos[j].familyTable.value2
                      } else {
                        this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.planos[j].familyTable.value2.replace(',','.'))).toFixed(2)
                      }
                      this.valorPlano = this.planos[j].familyTable.value2
                    }

                    else if (count + 1 == 3 && this.planos[j].familyTable.value3 != '') {
                      this.dependentes[i].valuePlan = this.planos[j].familyTable.value3
                      this.valorFaixa = (parseFloat(this.planos[j].familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                      if (this.dependentes[i].isHolder) {
                        this.valorTitular = this.planos[j].familyTable.value3
                      } else {
                        this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) +  parseFloat(this.planos[j].familyTable.value3.replace(',','.'))).toFixed(2)
                      }
                      this.valorPlano = this.planos[j].familyTable.value3
                    }

                    else if (count + 1 >= 4 && this.planos[j].familyTable.value4 != '') {
                      this.dependentes[i].valuePlan = this.planos[j].familyTable.value4
                      this.valorFaixa = (parseFloat(this.planos[j].familyTable.value4.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                      if (this.dependentes[i].isHolder) {
                        this.valorTitular = this.planos[j].familyTable.value4
                      } else {
                        this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.planos[j].familyTable.value4.replace(',','.'))).toFixed(2)
                      }
                      this.valorPlano = this.planos[j].familyTable.value4
                    }

                    else if (count + 1 >= 5 && this.planos[j].familyTable.value5 != '') {
                      this.dependentes[i].valuePlan = this.planos[j].familyTable.value5
                      this.valorFaixa = (parseFloat(this.planos[j].familyTable.value5.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                      if (this.dependentes[i].isHolder) {
                        this.valorTitular = this.planos[j].familyTable.value5
                      } else {
                        this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.planos[j].familyTable.value5.replace(',','.'))).toFixed(2)
                      }
                      this.valorPlano = this.planos[j].familyTable.value5
                    }

                    else if (count + 1 >= 6 && this.planos[j].familyTable.value6 != '') {
                      this.dependentes[i].valuePlan = this.planos[j].familyTable.value6
                      this.valorFaixa = (parseFloat(this.planos[j].familyTable.value6.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                      if (this.dependentes[i].isHolder) {
                        this.valorTitular = this.planos[j].familyTable.value6
                      } else {
                        this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.planos[j].familyTable.value6.replace(',','.'))).toFixed(2)
                      }
                      this.valorPlano = this.planos[j].familyTable.value6
                    } */
                  }
                }
              }
              this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes)).toFixed(2)
              this.valorAnualProposta = this.valorTotalProposta.replace(',','.') * 12
            }
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar os dependentes","ERRO")
        }

        //Verifica se existe titular
        if (this.dependentes.length > 0) {
          this.alertTitular = false
          this.existeTitular = true
        } else {
          this.alertTitular = true
          this.existeTitular = false
        }
      },

      async aplicaCupom() {
        var vm = this;
        if (this.financialManagers.cupomDesconto != '') {
          this.isLoading = true
          try {
            let res = await axios.post(`${baseApiUrl}Cupons/check`, {"cupom":this.financialManagers.cupomDesconto})
            this.dadosCupom = res.data            
            if (this.dadosCupom.dados == null) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825",this.dadosCupom.mensagem,"ATENÇÃO");
            } else {
              this.dependentes.forEach(dependente => {
                if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                  this.cupomAdesao = true
                  if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                    if (this.dadosCupom.dados.tipoValor == 'REAL') {
                      this.primeiraParcela = (parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor))
                      this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.')) * 11
                      this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                      dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                    } else {
                      this.primeiraParcela = parseFloat(dependente.valuePlan.replace(",",".")) - (parseFloat(dependente.valuePlan.replace(",",".") * (this.dadosCupom.dados.valor / 100)))
                      this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.')) * 11
                      this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                      dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                    }
                  } else {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
                  }
                } else {
                  if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                    if (this.dadosCupom.dados.tipoValor == 'REAL') {
                      this.valorAnualProposta = ((parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor)*12) * this.dependentes.length)
                      dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                      this.valorDependnte = dependente.valuePlan
                    } else {
                      this.valorAnualProposta = ((parseFloat(dependente.valuePlan.replace(",",".")) * this.dependentes.length)*12)
                      this.valorAnualProposta = this.valorAnualProposta - (this.valorAnualProposta * this.dadosCupom.dados.valor / 100)
                      dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                      this.valorDependnte = dependente.valuePlan
                    }
                  } else {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
                  }
                }
              });
              this.calculaValoresCupom()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe-nos, ocorreu um erro ao consultar o cupom!","ERRO");
          }
        }
      },

      excluiCupom() {
        this.carregaDependentes()
        this.cupomAdesao = false
      },

      calculaValoresCupom() {
        this.valorDependentes = '0,00'
        for (let index = 0; index < this.dependentes.length; index++) {
          if (!this.dependentes[index].isHolder) {
            this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.dependentes[index].valuePlan.replace(',','.'))).toFixed(2).replace('.',',')
          } else {
            this.valorTitular = parseFloat(this.dependentes[index].valuePlan.replace(',','.')).toFixed(2).replace('.',',')
          }
        }
        this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
        this.financialManagers.responsibility = this.valorTotalProposta
        this.dependentes.forEach(dependente => {
          if (this.dadosCupom.dados.planos.includes(dependente.plansId))
            this.cupomAplicado = true
        })
        this.isLoading = false
      },

      async carregaFinancialManagers(){
        await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.idUser}).then(res => {  
          if (res.data != null) {    
            this.AtualFinancialManagers = res.data.financialManagers
          }                                    	
        })  
      },

      async salvarTitular(){ 
          //this.existeTitular = false
          await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
          .then(res => {        
            if (res.data.dependentes.length > 0) {
              this.existeTitular = true              
            }
            }) 
          if(!this.existeTitular) {                                    
          await axios.post(`${baseApiUrl}Dependents/editaDependente`, this.dependents ).then(res => {         
          if(res.data != ''){ 
            this.carregaDependentes()     
              }              	
          })
          }        
      },

      //Métodos de Pagamento
      async pagamentoBoleto(pagamentoTipo){
        var vm = this;
        let permiteEmitirBoleto
        if (this.planoSelecionado.name.includes('HOME CARE')) {
          if (this.contrataccept && this.obsHomeCare) {
            permiteEmitirBoleto = true
          } else {
            permiteEmitirBoleto = false
          }
        } else {
          if (this.contrataccept) {
            permiteEmitirBoleto = true
          } else {
            permiteEmitirBoleto = false
          }
        }
        if(permiteEmitirBoleto){
        this.isLoading = true
        await this.retornoViaCEP()
        this.token = ''
        this.idBoleto = ''
        //Criando data de vencimeto do boleto
        var datapagvenc = new Date();
        datapagvenc.setDate(new Date().getDate() + 2)
        var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
        //Preencher o campos do model de Boleto
        modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
        modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
        modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 33) + ', ' + this.financialManagers.addressNumber
        modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
        modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
        modelBoleto.pagadorUf = this.financialManagUF 
        modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
        modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
        //salvando o responsibility e o valor do boleto caso seja anual
        if(pagamentoTipo == 'anual')
        {
          this.financialManagers.modalidadePagamento = 'ANUAL'
          if(this.financialManagers.reteveAdesao)
          {
            this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
            modelBoleto.valorNominal = parseFloat((this.valorTotalProposta * 11) - ((this.valorTotalProposta * 11) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
          }
          else
          {
            this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
            modelBoleto.valorNominal = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
          }
        }
        else
        {
        this.financialManagers.modalidadePagamento = 'MENSAL'
        this.financialManagers.responsibility = this.valorTotalProposta
        modelBoleto.valorNominal = parseFloat(this.valorTotalProposta)
        }
        modelBoleto.mensagem = 'Referente ao plano ' + this.planoSelecionado.qualificacao + " - " + this.planoSelecionado.registro + " - Proposta de Número: " + this.financialManagers.proposalNumber
        modelBoleto.nsu = this.financialManagers.proposalNumber
        modelBoleto.nossoNumero = nossoNum.substr(0,12)
        modelBoleto.seuNumero = nossoNum.substr(0,12)
        
        //Gerando o Boleto e pegando o ID
        
        try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
              if(res.data != ''){
                  this.formOfPayment.type = 'BOLETO'
                  this.financialManagers.formOfPayment = 'BOLETO'
                  this.idBoleto = res.data.id
                  await this.atualizaValorPlanoDep()
                  await this.salvarFinancialManagerEFinalizar()

              }              
              } catch (error) {
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                  this.close()                 
              } 
       
        

        }
        else
        {
          this.isLoading = false
          if (this.planoSelecionado.name.includes('HOME CARE')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }
        
      },  

      async pagarPix() {
        let vm = this
        let permiteGerarPix
        if (this.planoSelecionado.name.includes('HOME CARE')) {
          if (this.contrataccept && this.obsHomeCare) {
            permiteGerarPix = true
          } else {
            permiteGerarPix = false
          }
        } else {
          if (this.contrataccept) {
            permiteGerarPix = true
          } else {
            permiteGerarPix = false
          }
        }
        if (permiteGerarPix) {
          this.isLoading = true
          await this.retornoViaCEP()
          this.token = ''
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate() + 2)
          var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
          this.modelPix.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
          this.modelPix.pagadorNome = this.financialManagers.firstName.substr(0, 39)
          this.modelPix.pagadorEndereco = this.financialManagers.address.substr(0, 33) + ', ' + this.financialManagers.addressNumber
          this.modelPix.pagadorBairro = this.bairro.substr(0, 19).replace("'", ' ')
          this.modelPix.pagadorCidade = this.cidade.substr(0, 19)
          this.modelPix.pagadorUf = this.financialManagUF 
          this.modelPix.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
          this.modelPix.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          this.modelPix.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          this.financialManagers.modalidadePagamento = 'MENSAL'
          this.financialManagers.responsibility = this.valorTotalProposta
          this.modelPix.valorNominal = parseFloat(this.valorTotalProposta)
          this.modelPix.mensagem = 'Referente ao plano ' + this.planoSelecionado.qualificacao + " - " + this.planoSelecionado.registro + " - Proposta de Número: " + this.financialManagers.proposalNumber
          this.modelPix.nsu = this.financialManagers.proposalNumber
          this.modelPix.nossoNumero = nossoNum.substr(0, 12)
          this.modelPix.seuNumero = nossoNum.substr(0, 12)
          this.modelPix.financialManagerId = this.idUser

          if (this.planoSelecionado.typePayment == 'CARTAO') {
            this.financialManagers.cardNumber = this.modelCartao.cartao.numero
            this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
            this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
            this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
            await this.salvarFinancialManager()
          }

          this.Sales.status = 'PAGAMENTO PENDENTE'
          
          this.Sales.fMIPConfirm = await this.pegaIp()
          this.Sales.salesmanIPConfirm = await this.pegaIp()
          this.Sales.brokerId = this.financialManagers.brokerId
          this.Sales.salesmanId = this.financialManagers.salesmanId
          this.Sales.financialManagerId = this.idUser
          this.Sales.fMConfirm = new Date().toISOString()
          this.Sales.salesmanConfirm = new Date().toISOString()
          await axios.post(baseApiUrl + 'FinancialManagers/setExistSales', this.Sales)

          await axios.post(baseApiUrl + 'Pagamentos/pixPost', this.modelPix)
          .then(async response => {
            if (response.data) {
              this.respostaPix = Object.assign({}, response.data.pix)
              this.dialogoTipoPagamento = false
              this.dialogoPix = true
              this.isLoading = false
              
              this.financialManagers.dateSignatureContract = new Date().toISOString().substring(0, 10)
              this.financialManagers.contractNumberS4 = await this.pegaFormOfPayment()
              this.financialManagers.formOfPayment = 'PIX'
              this.financialManagers.vendedor = this.nomeVendedor

              if (this.planoSelecionado.typePayment == 'CARTAO') {
                this.financialManagers.cardNumber = this.modelCartao.cartao.numero
                this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
                this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
                this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
                await this.atualizaValorPlanoDep()
              } else if (this.planoSelecionado.typePayment == 'BOLETO') {
                await this.atualizaValorPlanoDep()
              }

              this.salvarFinancialManager()
              
              this.consultaPix()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao gerar Pix, tente novamente!","DESCULPE");
          })
        } else {
          this.isLoading = false
          vm = this;
          if (this.planoSelecionado.name.includes('HOME CARE')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }
      },

      async consultaPix() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/consultaPix', { "pixId": this.respostaPix.id })
          .then(async response => {
            if (response.data.situacaoPix == 'PAGO') {
              clearInterval(this.verificaPagamento)
              this.isLoading = true
              this.dialogLoading = true
            }
          })
          .catch(() => {
            clearInterval(this.verificaPagamento)
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
          })
        }.bind(this), 5000)
      },

      gerarPixCartao() {
        var vm = this;
        if (!this.modelCartao.cartao.bandeira) {
          vm.$refs.chamaSnackbar.snack("#EF5350","Bandeira do cartão não localizada, por favor, revise os dados!","ERRO");
        } else if (this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.bandeira == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == null) {
          this.$validator.validateAll()
        } else {
          this.dialogoTipoPagamento = true
        }
      },

      async pegaFormOfPayment() {
        let codeS4
        let dados = {
          "costCenterId": this.planoSelecionado.costCenterId,
          "dayInclusion": new Date().getDate(),
          "type": this.planoSelecionado.typePayment,
        }

        await axios.post(baseApiUrl + 'FormOfPayments/firstPaymentDate', dados)
        .then(response => {
          if (response.data) {
            codeS4 = response.data.codeS4
          }
        })

        return codeS4
      },

      async pegaIp() {
        let ip

        await axios.get('https://api.ipify.org/?format=json')
        .then(response => {
          if (response.data) { 
            ip = response.data.ip
          } else {
            ip = '127.0.0.0'
          }
        })

        return ip
      },
      
      pagamentoCartao(pagamentoTipo){
        if(this.financialManagers.reteveAdesao && pagamentoTipo == 'mensal')
          this.pegaDadosCartao = true
        else
          this.pegaDadosCartao = false
        let permitePagarCartao
        if (this.planoSelecionado.name.includes('HOME CARE')) {
          if (this.contrataccept && this.obsHomeCare) {
            permitePagarCartao = true
          } else {
            permitePagarCartao = false
          }
        } else {
          if (this.contrataccept) {
            permitePagarCartao = true
          } else {
            permitePagarCartao = false
          }
        }
        if(permitePagarCartao){
        this.validadeCartao = ''
        this.pagamentoTipoCartao = pagamentoTipo
        this.dialogCartao = true
         }
        else
        {
          var vm = this;
          if (this.planoSelecionado.name.includes('HOME CARE')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }

      },

      async gerarBoletoCartao(pagamentoTipo) {
        var vm = this;
        if (this.modelCartao.cartao.numero != '' || this.modelCartao.cartao.bandeira != '' || this.modelCartao.cartao.nome != '' || this.modelCartao.cartao.codigoSeguranca != '' || this.modelCartao.cartao.expiracaoMes != '' || this.validadeCartaoAno != null) {
          this.isLoading = true
          await this.retornoViaCEP()
          this.token = ''
          this.idBoleto = ''
          //Criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate() + 2)
          var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
          //Preencher o campos do model de Boleto
          modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
          modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 33) + ', ' + this.financialManagers.addressNumber
          modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
          modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
          modelBoleto.pagadorUf = this.financialManagUF 
          modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          //salvando o responsibility e o valor do boleto caso seja anual
          if (pagamentoTipo == 'anual') {
            this.financialManagers.modalidadePagamento = 'ANUAL'
            if (this.financialManagers.reteveAdesao) {
              this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
              modelBoleto.valorNominal = parseFloat((this.valorTotalProposta * 11) - ((this.valorTotalProposta * 11) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
            } else {
              this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
              modelBoleto.valorNominal = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
            }
          } else {
            this.financialManagers.modalidadePagamento = 'MENSAL'
            this.financialManagers.responsibility = this.valorTotalProposta
            modelBoleto.valorNominal = parseFloat(this.valorTotalProposta)
          }
          modelBoleto.mensagem = 'Referente ao plano ' + this.planoSelecionado.qualificacao + " - " + this.planoSelecionado.registro + " - Proposta de Número: " + this.financialManagers.proposalNumber
          modelBoleto.nsu = this.financialManagers.proposalNumber
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          //Gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
              this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
              this.formOfPayment.type = 'CARTAO'
              this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
              this.financialManagers.formOfPayment = 'CARTAO'
              this.financialManagers.cardCvc = await this.encrypt(this.modelCartao.cartao.codigoSeguranca)
              this.financialManagers.cardNumber = this.modelCartao.cartao.numero
              this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
              this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
              this.financialManagers.cardFlag = this.getCardFlag(this.modelCartao.cartao.numero)
              this.idBoleto = res.data.id
              await this.atualizaValorPlanoDep()
              await this.salvarFinancialManagerEFinalizar()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
            this.close()                 
          }
        } else {
          this.isLoading = false
          if (this.planoSelecionado.name.includes('HOME CARE')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }
      },

      async encrypt(text) {
        let encryptedData
        await axios.post(baseApiUrl + 'FinancialManagers/encrypt', {"text": text})
        .then(response => {
          if (response.data.encrypt) {
            encryptedData = response.data.encrypt
          }
        })
        return encryptedData
      },

      async enviarProposta(){ 
        this.isLoading = true
        var vm = this;
        this.Sales.status = 'EM VALIDAÇÃO'
        let permitePagarCartao
        if (this.planoSelecionado.name.includes('HOME CARE')) {
          if (this.contrataccept && this.obsHomeCare) {
            permitePagarCartao = true
          } else {
            permitePagarCartao = false
          }
        } else {
          if (this.contrataccept) {
            permitePagarCartao = true
          } else {
            permitePagarCartao = false
          }
        }
        if(this.planoSelecionado.typePayment == 'BOLETO')
        {
        if(permitePagarCartao){
            this.financialManagers.formOfPayment = 'BOLETO'     
            this.financialManagers.responsibility = this.valorTotalProposta
            await this.atualizaValorPlanoDep()
            await this.salvarFinancialManagerEFinalizar()
        }
        else{
          this.isLoading = false
          if (this.planoSelecionado.name.includes('HOME CARE')) {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }
        }
        else if(this.planoSelecionado.typePayment == 'CARTAO')
        {           
        if(!permitePagarCartao){
            this.isLoading = false
            if (this.planoSelecionado.name.includes('HOME CARE')) {
              vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato e das observações acima!","ATENÇÃO");
            } else {
              vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é necessário concordar com os termos do contrato!","ATENÇÃO");
            }
        }
        else
        {
        if(this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == '')
          {
            this.$validator.validateAll()
          }
        else
        {
            this.isLoading = true
            //Pega hash cvv e salva no FM
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
              if(res.data.encrypt != '')
                this.financialManagers.cardCvc = res.data.encrypt              
            } catch (error) {
              this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
                  return;
            }
            this.financialManagers.responsibility = this.valorTotalProposta
            this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
            this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
            this.formOfPayment.type = 'CARTAO'
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            this.financialManagers.formOfPayment = 'CARTAO'
            this.financialManagers.cardNumber = this.modelCartao.cartao.numero
            this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
            this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
            this.financialManagers.cardFlag = this.getCardFlag(this.modelCartao.cartao.numero)


            await this.atualizaValorPlanoDep()
            await this.salvarFinancialManagerEFinalizar()
        }
        }
        }
      },

      async atualizaValorPlanoDep() {
        this.dependentes.forEach(async dependente => {
          try {
            delete dependente.qualificacao
            /* if (this.cupomAplicado) {
              if (this.dadosCupom.dados.tipoDesconto == 'ADESÃO') {
                await axios.post(baseApiUrl + `Dependents/update?[where][financialManagerId]=${this.idUser}`, {"valuePlan":this.valorPlano.replace('.',',')})
              } else {
                await axios.put(baseApiUrl + 'Dependents', dependente)
              }
            } else {
              await axios.post(baseApiUrl + `Dependents/update?[where][financialManagerId]=${this.idUser}`, {"valuePlan":this.valorPlano.replace('.',',')})
            } */
            await axios.post(baseApiUrl + 'Dependents/editaDependente', dependente)
          } catch (error) {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao atualizar valor do plano para os dependentes!","DESCULPE")
          }
        })
      },

      async pagarCartao(){ 
        if(!this.modelCartao.cartao.bandeira)
            {
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Bandeira do cartão não localizada, por favor, revise os dados!","ERRO");
            }
          else 
          if(this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.bandeira == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == null)
          {                       
            this.$validator.validateAll()
          }
          else
          {
            this.isLoading = true
            await this.retornoViaCEP()
            var primeiroUltimoNome = this.financialManagers.firstName.trim().split(" ") 
            this.modelCartao.id = this.encrypt(this.financialManagers.proposalNumber.toString())
            if(this.pagamentoTipoCartao == 'anual')
            {
              this.modelCartao.tipoTransacao = 'A_VISTA'
              this.financialManagers.modalidadePagamento = 'ANUAL'
              if(this.financialManagers.reteveAdesao)
                {
                  this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
                  this.modelCartao.valor = parseFloat((this.valorTotalProposta * 11) - ((this.valorTotalProposta * 11) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
                }
              else
                {
                  this.financialManagers.responsibility = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace('.', ',')
                  this.modelCartao.valor = parseFloat((this.valorTotalProposta * 12) - ((this.valorTotalProposta * 12) * (this.planoSelecionado.descontoAnual/100))).toFixed(2).replace(',', '.')
                }
            }
            else
            if(this.pagamentoTipoCartao == 'anualParcelado')
            {
              this.modelCartao.tipoTransacao = 'PARCELADO_SEM_JUROS'            
              this.financialManagers.modalidadePagamento = 'ANUAL'
              if(this.financialManagers.reteveAdesao)
                {
                  this.modelCartao.quantidadeParcelas = 11
                  this.financialManagers.responsibility = parseFloat(this.valorTotalProposta * 12).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat(this.valorTotalProposta * 11).toFixed(2).replace(',', '.')
                }
              else
                {
                  this.modelCartao.quantidadeParcelas = 12
                  this.financialManagers.responsibility = parseFloat(this.valorTotalProposta * 12).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat(this.valorTotalProposta * 12).toFixed(2).replace(',', '.')
                }            
            }
            else
            if(this.pagamentoTipoCartao == 'mensal')
            {
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.financialManagers.modalidadePagamento = 'MENSAL'
            this.financialManagers.responsibility = this.valorTotalProposta
            this.modelCartao.valor = this.valorTotalProposta
            }
            this.modelCartao.comprador.id = this.idUser.replace(/[^\d]+/g,'').substr(0, 9)
            this.modelCartao.comprador.documentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.financialManagers.email
            this.modelCartao.comprador.nomeCompleto = this.financialManagers.firstName
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = this.financialManagers.address
            this.modelCartao.comprador.enderecoNumero = this.financialManagers.addressNumber
            this.modelCartao.comprador.enderecoComplemento = this.financialManagers.addressComplement
            this.modelCartao.comprador.enderecoCep = this.financialManagers.cep.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.enderecoBairro = this.bairro
            this.modelCartao.comprador.enderecoCidade = this.cidade
            this.modelCartao.comprador.enderecoEstado = this.estado
            //this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.expiracaoAno = this.validadeCartaoAno.substr(2,4)
            //this.modelCartao.cartao.bandeira = this.getCardFlag(this.modelCartao.cartao.numero)
            this.modelCartao.cartao.bandeira = this.modelCartao.cartao.bandeira

            //Pega hash cvv e salva no FM
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
              if(res.data.encrypt != '')
                this.financialManagers.cardCvc = res.data.encrypt              
            } catch (error) {
              this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
                  return;
            }

            // Dados para o FM
            this.financialManagers.cardCvc = this.encrypt(this.modelCartao.cartao.codigoSeguranca.toString())           
            this.financialManagers.cardNumber = this.modelCartao.cartao.numero
            this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
            this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
            this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
            this.financialManagers.formOfPayment = 'CARTAO'
            await this.salvarFinancialManager()

              try {
                let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao)
              if(res.data != ''){   
                            
                  this.Sales.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                  this.Sales.nsu = res.data.transacao.nsu
                  this.Sales.paymentId = res.data.pagamentoId
                  this.financialManagers.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                  this.financialManagers.nsu = res.data.transacao.nsu
                  this.financialManagers.paymentId = res.data.pagamentoId
                  this.financialManagers.tokenCartao = res.data.cartaoId
                  this.financialManagers.cardCvc = ''
                  this.financialManagers.cardNumber = ''
                  this.financialManagers.cardValidity = ''
                  this.financialManagers.cardHolderName = ''
                  this.financialManagers.cardFlag = ''
                  this.Sales.status = 'EM VALIDAÇÃO'
                  this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
                  this.financialManagers.vendedor = this.nomeVendedor
                  //this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                  //Pegar o formOfPayment e Salvar FinancialManager
                  this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
                  this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
                  this.formOfPayment.type = 'CARTAO'
                  await this.atualizaValorPlanoDep()
                  await this.salvarFinancialManagerEFinalizar()
                  /* this.cartaValidado = true
                  if(this.cartaValidado)
                    {
                      await this.atualizaValorPlanoDep()
                      await this.salvarFinancialManagerEFinalizar()

                    }
                    else
                    {
                      this.isLoading = false
                      var vm = this;
                      vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + res.data.mensagem,"ERRO") 
                    } */

              }              
              } catch (error) {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento. " + JSON.parse(error.response.data.detalhes).erroMensagemAmigavel + ". Cód.: " + JSON.parse(error.response.data.detalhes).codigo,"ERRO") 
              }           
            /* await axios.post("https://p4x.srv.br/api/v1.0/pagamentos/cartaocredito",this.modelCartao, { */            
            
          }
          
      },            

      async salvarDependentesCarregados(){
        for(var i=1; i<=this.financialManagers[0].qtdDependentes; i++) {
          this.dependents.valuePlan = this.planoSelecionado.value
          this.dependents.dateOfBirth = this.formatDate(this.dependentesCarregados[i].DataNascimento)
          this.dependents.plansId = this.planoSelecionado.id
          this.dependents.valuePlan = this.planoSelecionado.value
          this.dependents.rcaId = '8'
          this.dependents.financialManagerId = this.idUser
          this.dependents.isHolder = false
          this.dependents.firstName = this.dependentesCarregados[i].Nome
          //this.dependents.gender = this.financialManagers.gender
          //this.dependents.maritalStatus = this.financialManagers.maritalStatus
          this.dependents.cpf = this.dependentesCarregados[i].CPF
          this.dependents.motherName = this.dependentesCarregados[i].NomeMaeDependente
          this.dependents.susNumber = this.dependentesCarregados[i].CNS
          switch (this.dependentesCarregados[i].CodGrauParentesco) {
            case 3:
                this.dependents.parentage = 'CÔNJUGE'
              break;
            case 4:
                this.dependents.parentage = 'FILHO'
              break;
            case 6:
                this.dependents.parentage = 'ENTEADO'
              break;
            case 8:
                this.dependents.parentage = 'PAI/MÃE'
              break;
            case 10:
                this.dependents.parentage = 'OUTRO'
              break;          
            default:
              break;
          }

          await axios.post(`${baseApiUrl}Dependents/editaDependente`, this.dependents ).then(res => {         
                if(res.data != ''){    
                    this.carregaDependentes()
                    this.dependents = Object.assign({}, this.defaultDependents)
                    //this.qtdDependentesInseridos = res.data
                    }              	
                })
        }

      },

      async salvarDependente(){

      await this.$validator.validate('dateOfBirthDep').then(valid => {
        if (!valid)
          this.validarDataNascDep = false
        else
          this.validarDataNascDep = true
      });

      this.dependents.valuePlan = this.planoSelecionado.value
      this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
      this.dependents.plansId = this.planoSelecionado.id
      this.dependents.rcaId = '8'
      this.dependents.financialManagerId = this.idUser
      this.selecionaPlanoDepend()
      if(this.tipoTitular)
      this.dependents.isHolder = true
      else
      this.dependents.isHolder = false
        if(this.dependents.dateOfBirth == '' || this.dependents.firstName == '' || !this.validarDataNascDep)
            this.$validator.validateAll()
        else
        if(this.calculateAge(this.dependents.dateOfBirth) >= 12 && this.dependents.cpf == '')
            this.$validator.validateAll() 
        else
          if(this.dependents.isHolder == false && this.dependents.parentage == '' )
          this.$validator.validate('parentage') 
        else
        if(!CpfValidate(this.dependents.cpf) && this.dependents.cpf != '')
          this.$validator.validateAll() 
            else{
              //Verifica se o beneficiário é titular, se for, verifica se ele ja tem cadastro ativo.
                if(this.dependents.isHolder && this.dependents.cpf != ''){
                await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.dependents.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
                  if(res.data.Data.length > 0){
                 res.data.Data.forEach( (titular) => {
                  if(titular.Dependente[0].Situacao == "1")
                      {
                        this.verificaTitularS4e = true
                      }
                  else{ 
                        this.verificaTitularS4e = false
                      }
                      })
                    }
                    else{ 
                      this.verificaTitularS4e = false
                    }              
                  })  
                }
                if(!this.financialManagers.contratanteTitular && this.verificaTitularS4e) 
                {
                  this.isLoading = false
                  var vm2 = this;
                  vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
                } 
                else{ 
                this.dependents.firstName = this.dependents.firstName.toUpperCase()                          
                await axios.post(`${baseApiUrl}Dependents/editaDependente`, this.dependents ).then(res => {         
                if(res.data != ''){      
                    this.carregaDependentes()
                    this.close()
                    }              	
                })
                  if(this.dependents.parentage == ''){
                  this.alertTitular = false 
                  } 
                }             
            }           
      },

      selecionaPlanoDepend() {
        for (var i = 0; i < this.planos.length; i++) {
          if (this.planos[i].id === this.selecaoPlano) {
            this.dependents.plansId = this.planos[i].id
            this.dependents.valuePlan = this.planos[i].value
            this.dependents.namePlan = this.planos[i].name           
            this.dependents.qualificacao = this.planos[i].qualificacao
          }
        }
      },
      
     async finalizaCadastro(){
       //PEGA O CONTRACT NUMBER S4
       try {  
              let res = await axios.post(`${baseApiUrl}FormOfPayments/firstPaymentDate`,this.formOfPayment)
                if(res.data != ''){        
                  this.financialManagers.contractNumberS4 = res.data.codeS4
                  //this.salvarFinancialManager()
                } 
                else
                {             
                  this.financialManagers.contractNumberS4 = ''
                  //this.salvarFinancialManager()
                }
            } catch (error) {
              this.financialManagers.contractNumberS4 = ''
              //this.salvarFinancialManager()
            }
        
        //ATUALIZA O FINANCIAL MANAGER E SALVA O SALES
        if(this.financialManagers.contractNumberS4 != undefined && this.financialManagers.contractNumberS4 != '')
        {          
          try {
                  await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers)            
              } 
          catch (error) 
              {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
              }
        if(Object.entries(this.vendedorLink).length != 0)
        {
            this.Sales.brokerId = this.vendedorLink.brokerId
            this.Sales.salesmanId = this.vendedorLink.id
          try {
          let res = await axios.get(`https://api.ipify.org/?format=json`)
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }
              else
              {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'
              }
          } catch (error) {
                  this.Sales.fMIPConfirm = '127.0.0.0' 
                  this.Sales.salesmanIPConfirm = '127.0.0.0'  
          }
            this.Sales.financialManagerId = this.idUser
            this.Sales.fMConfirm = new Date().toISOString()
            this.Sales.salesmanConfirm = new Date().toISOString()
          try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
              if(res.data == true){ 
                if((this.planoSelecionado.typePayment == 'BOLETO' || this.planoSelecionado.typePayment == 'CARTAO' && this.financialManagers.reteveAdesao == false) || (this.idBoleto))
                {
                  //if(!this.financialManagers.reteveAdesao)
                  this.imprimirBoleto()
                  setTimeout(() => {
                  this.isLoading = false
                  this.dialogLoading = true
                  }, 4000);
                }
                else
                {
                this.isLoading = false
                this.dialogLoading = true
                }
              } 
              else
              {
                this.isLoading = false
                this.dialogLoading = true             
                  /* this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") */  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
        }
        else
        {
        this.Sales.brokerId = this.brokerOralsantahelena
        this.Sales.salesmanId = this.salesOralsantahelena 
        try {
          let res = await axios.get(`https://api.ipify.org/?format=json`)
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }
              else
              {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'
              }
        } catch (error) {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'  
        }
        this.Sales.financialManagerId = this.idUser
        this.Sales.fMConfirm = new Date().toISOString()
        this.Sales.salesmanConfirm = new Date().toISOString()
        try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
              if(res.data == true){ 
                if((this.planoSelecionado.typePayment == 'BOLETO' || this.planoSelecionado.typePayment == 'CARTAO' && this.financialManagers.reteveAdesao == false) || (this.idBoleto))
                {
                  //if(!this.financialManagers.reteveAdesao)
                  this.imprimirBoleto()
                  setTimeout(() => {
                  this.isLoading = false
                  this.dialogLoading = true
                  }, 4000);
                }
                else
                {
                this.isLoading = false
                this.dialogLoading = true
                }
              } 
              else
              {   
                this.isLoading = false
                this.dialogLoading = true          
                  /* this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") */  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
        }
      }
      else
          {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um erro ao capturar a forma de pagamento, tente novamente!","ERRO")  
          }
      },

    async imprimirBoleto()
    {
    //Baixando Boleto PDF
    try {
        let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token           
            'Content-type': 'application/pdf'
          }
          })
        if(res.data != null){
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data], 
              {type: 'application/pdf'});
              //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.setAttribute('download', 'boleto.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
            //Open the URL on new Window
                window.open(fileURL);                           
        }              
        } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto, tente novamente ou entre em contato com a Oral Santa Helena!","ERRO");
            this.close()                 
        }
    },

      openDialog(){
        this.tipoTitular = true
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          this.dependents.isHolder = true
        this.dialog = true
      },
      openDialogDependete(){
        this.selecaoPlano = this.planoSelecionado.id
        this.tipoTitular = false
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
        this.dialog = true
      },
      openDialogDelete(item){
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },
      close() {
        this.dialogCartao = false
          this.dialogLoading = false
          this.dialog = false
          this.dialogDelete = false
          this.$validator.reset()          
          setTimeout(() => {
            this.modelCartao = Object.assign({}, this.defaltModelCartao)
            this.$validator.reset()
            this.usarDadosFM = true
          }, 800);
          setTimeout(() => {
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          }, 300)
      },

      confirmaContrato(){
        this.close()
        this.$router.push({ path: '/areacliente' })
        /* setTimeout(() => {
            document.location.reload(true);
        }, 500); */
      },
      getCardFlag(cardnumber) {
        cardnumber.replace(/[^0-9]+/g, '');

        var cards = {
            visa      : /^4[0-9]{12}(?:[0-9]{3})/,
            mastercard : /^5[1-5][0-9]{14}/,
            diners    : /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
            /* amex      : /^3[47][0-9]{13}/,
            discover  : /^6(?:011|5[0-9]{2})[0-9]{12}/, */
            hipercard  : /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
            elo        : /^((((636368)|(655001)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(6505)|(4011))\d{0,12})/,
            /* jcb        : /^(?:2131|1800|35\d{3})\d{11}/,        
            aura      : /^(5078\d{2})(\d{2})(\d{11})$/  */     
        };

        for (var flag in cards) {
            if(cards[flag].test(cardnumber)) {
                return flag.toUpperCase();
            }
        }        

        return false;
    },

    //CONTROLE DE ANEXOS

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    
    inputFileRg1(newFile, oldFile) {
      if (newFile && !oldFile) {       
        var reader = new FileReader();        
        var file = this.filesRg1[0]
        
        //salva a base64 na variável
        reader.onloadend = function() { 
                  
         document.getElementById("rg1").value = reader.result            
        
        };            
        //Gera base64
        reader.readAsDataURL(file.file);  
        //this.files = []     

      }
      if (newFile && oldFile) {
        // update
      }
      if (!newFile && oldFile) {
        // remove
      }
    },
    
      inputFileRg2(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesRg2[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("rg2").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

      inputFileCPF(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesCPF[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("cpf").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    inputFileAddress(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesAddress[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("address").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    inputFileOutros(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesOutros[0]
        //Gera base643
        reader.onloadend = function() { 

          document.getElementById("outros").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },


      //FIM CONTROLE DE ANEXOS
    
        calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if(birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },
    async pegaParametrosUrl(){
      this.isLoading = true
      var params = window.location.search.substring(1).split('&');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }
      if(paramArray['plano'])
      {
      sessionStorage.clear()
      }
      if(paramArray['parceria'] == 'avanti')
      this.linkParceriaAvanti = true
      else
      if(paramArray['parceria'] == 'igrejas')
      this.linkParceriaIgrejas = true

      if(paramArray['carteirinha'])
      this.financialManagers.matricula = paramArray['carteirinha']

      if(paramArray['cpf'])
      {
        //DADOS PARA TODOS
        this.financialManagers.contractNumberS4 = 63744
        this.financialManagers.cpf = paramArray['cpf']

        this.$validator.localize('pt', this.dictionary)
        await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": paramArray['cpf'].replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if(res.data.Data.length > 0){      
                res.data.Data.forEach( (titularContrato) => {
                  if(titularContrato.CodigoEmpresa == 5085)
                  {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#0288D1","Detectamos que você já tem cadastro na Oral Santa Helena, confirme os seus dados na proposta","INFORMAÇÃO");

                  //CARREGA DEPENDENTES
                  for(var i=0; i<titularContrato.Dependente.length; i++) {

                  this.dependentesCarregados.push(titularContrato.Dependente[i])
                  }

                  //PREENCHIMENTO DOS CAMPOS
                  this.financialManagers.qtdDependentes = titularContrato.Dependente.length -1                  
                  this.financialManagers.state = titularContrato.Uf
                  this.financialManagers.rg = titularContrato.Identidade
                  this.financialManagers.firstName = titularContrato.Nome.trim()
                  this.financialManagers.motherName = titularContrato.Dependente[0].NomeMaeDependente.trim()
                  this.financialManagers.susNumber = titularContrato.Dependente[0].CNS
                  this.financialManagers.cpf = titularContrato.CPF
                  this.financialManagers.cep = titularContrato.Cep
                  for(var c=0; c<titularContrato.Contato.length; c++) {
                    if(titularContrato.Contato[c].Tipo == 'E-mail' && titularContrato.Contato[c].situacao == 1)
                    {
                    this.financialManagers.email = titularContrato.Contato[c].descricao.trim()
                    }

                    if(titularContrato.Contato[c].Tipo == 'Celular' || titularContrato.Contato[c].Tipo == 'Fixo' || titularContrato.Contato[c].Tipo == 'Telefone' && titularContrato.Contato[c].situacao == 1)
                    {
                    this.financialManagers.cellPhone = titularContrato.Contato[c].descricao
                    }
                  }
                  if(titularContrato.Sexo == 'M'){
                  this.financialManagers.gender = 1
                  }    
                  else
                  {
                  this.financialManagers.gender = 0
                  }
                  this.financialManagers.rg = titularContrato.Identidade
                  this.dataNasc = titularContrato.DataNascimento
                  this.financialManagers.addressNumber = titularContrato.Numero                 
                  this.financialManagers.addressComplement = titularContrato.Complemento 
                  }                          
                  })
              }             
            })
      }
      

      await axios.get(`${baseApiUrl}Plans?filter[where][id]=${paramArray['plano']}`).then(res => {        
            if(res.data != null){
            this.financialManagers.plansId = paramArray['plano']      
            this.planoSelecionado = res.data[0]
            this.pdfSelecionado = this.planoSelecionado.urlMinutaContrato   
            }              	
      })
      if(paramArray['vendedor'])
          {
          await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {        
            if(res.data != null){
            this.vendedorLink = res.data[0] 
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite
            this.financialManagers.vendedor = this.vendedorLink.linkSite 
            this.financialManagers.CPFVendedor =  this.vendedorLink.cpf     
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId        
          }
          })
          } 
    }
    this.isLoading = false
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar.texto = 'Chave copiada para a área de transferência!'
        this.snackbar.cor = 'success'
      } catch (error) {
        this.snackbar.cor = 'warning'
        this.snackbar.texto = 'Problema ao copiar chave para a área de transferência'
      }
      this.snackbar.ativo = true
    },

    retornaPlano(id) {
      for (let i = 0; i < this.planos.length; i++) {
        if (this.planos[i].id == id) {
          return this.planos[i].qualificacao
        }
      }
    },

    async pegaDocumentos(idPlano) {
      await axios.get(baseApiUrl + 'Plans/' + idPlano + '?filter={"fields":{"name":true, "urlContrato":true, "urlAditivo": true, "urlManual": true, "urlGuia": true, "urlMinutaContrato": true, "urlMinutaAditivo": true, "urlCobertura":true, "id":true}}')
      .then(response => {
        if (response.data) {
          if (this.documentosPlano.length == 0) {
            this.documentosPlano.push(response.data)
          } else {
            let indice = this.documentosPlano.findIndex(function(planoFind) {
              return planoFind.id === response.data.id;
            });

            indice == -1 ? this.documentosPlano.push(response.data) : ''
          }
        }
      }).catch(() => {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar planos","DESCULPE");
      })
    },

    criaTituloPagina() {
      let mensagem = ''
      for (let i = 0; i < this.dependentes.length; i++) {
        for (let j = 0; j < this.planos.length; j++) {
          if (this.dependentes[i].plansId == this.planos[j].id) {
            if (this.planos[j].qualificacao == 'Individual') {
              mensagem = this.planos[j].name + ' - ' + this.planos[j].registro + ' - R$ ' + this.planos[j].value + ' (Por pessoa) - ' + this.planos[j].cobertura
            }
            else {
              mensagem = this.planos[j].name + ' - ' + this.planos[j].registro + ' - R$ ' + this.planos[j].value + ' (Até 4 pessoas) - ' + this.planos[j].cobertura
            }

            this.tituloContratacao.push(mensagem)
          }
        }
      }
    },
    },    

}
</script>

<style>
.v-table__overflow {
    border-radius: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

span.v-stepper__step__step.primary{
    background-color: #00b21e!important;
    border-color: #00b21e!important;
}

.theme--light.v-stepper .v-stepper__label {
    color: #00b21e;
}
.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #00b21e;
}

table.v-table thead tr th {
    background-color: #00b21e;
    font-size: 1rem;
  }

.v-list__tile.theme--light{
  justify-content: center;
}

.centralizar {
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
}


  .theme--light.v-table thead th  {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .theme--light.v-datatable thead th.column.sortable.active {
    color: white;
    font-weight: bold;
  }

  table.v-table thead th:first-child, table.v-table tbody th:first-child {
    padding: 15px 24px;
  }   
  .form-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #00b21e;
    margin-bottom: 20px;
  }

  hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
  .resumo p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    color: #828585;
  }
  .subtotal {
    font-weight: 700;
    font-size: 20px;
    color: #828585;
  }
  .total {
    font-size: 30px;
    color: #00b21e;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;
  }
  .page-content p {
    margin-bottom: 0;
  }
  .cardpag{
    background-color: #00b21e;
    color: white;
  /*   color: #00b21e; */
    justify-content: center;
    font-weight: 700;
    font-size: 20px;
  }
  a{
    text-decoration: none
  }

  .imgpag{
    opacity: 0.5;
  }

</style>
